/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/feature/additional/additional-edit.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../public/upgrade/core/point-of-sale.service.service';
import * as import6 from '../../../../../public/upgrade/feature/additional/additional.service';
import * as import7 from '../../../../../public/upgrade/feature/additional/additional-validations.service';
import * as import8 from '@angular/core/src/linker/view_type';
import * as import9 from '@angular/core/src/change_detection/constants';
import * as import10 from '@angular/core/src/linker/component_factory';
import * as import11 from '@angular/http/src/http';
import * as import12 from '@angular/core/src/zone/ng_zone';
import * as import13 from '@angular/router/src/router_state';
import * as import14 from '../../../../../public/upgrade/root/toast/notification.service';
import * as import15 from '@angular/router/src/router';
import * as import16 from '../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import17 from '@angular/forms/src/form_builder';
import * as import18 from '../../../../../public/upgrade/root/modal/modal.service';
import * as import19 from '../../../../../public/upgrade/core/session.service';
import * as import20 from '../../../../../public/upgrade/root/sidebar/sidebar.service';
import * as import21 from '../../../../../public/upgrade/shared/checkbox-container/checkbox-container.component';
import * as import22 from '../../shared/checkbox-container/checkbox-container.component.ngfactory';
import * as import23 from '@angular/core/src/linker/view_container';
import * as import24 from '@angular/core/src/change_detection/change_detection_util';
import * as import25 from '../../../../../public/upgrade/shared/radio-container/radio-container.component';
import * as import26 from '../../shared/radio-container/radio-container.component.ngfactory';
import * as import27 from '@ngx-translate/core/src/translate.pipe';
import * as import28 from '@ngx-translate/core/src/translate.service';
import * as import29 from '../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import30 from '@angular/core/src/linker/template_ref';
import * as import31 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import32 from '@angular/common/src/directives/ng_for';
import * as import33 from '../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import34 from '@angular/common/src/directives/ng_if';
import * as import35 from '../../../../../public/upgrade/shared/input-container/input-container.component';
import * as import36 from '../../shared/input-container/input-container.component.ngfactory';
import * as import37 from '../../../../node_modules/@angular/forms/src/directives/ng_form.ngfactory';
import * as import38 from '../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import39 from '../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import40 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import41 from '@angular/core/src/linker/element_ref';
import * as import42 from '@angular/common/src/directives/ng_class';
import * as import43 from '@angular/forms/src/directives/ng_form';
import * as import44 from '@angular/forms/src/directives/control_container';
import * as import45 from '@angular/forms/src/directives/ng_control_status';
import * as import46 from '@angular/core/src/security';
export class Wrapper_AdditionalEditComponent {
  /*private*/ _eventHandler:Function;
  context:import0.AdditionalEditComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any,p10:any,p11:any) {
    this._changed = false;
    this.context = new import0.AdditionalEditComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_AdditionalEditComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_AdditionalEditComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.AdditionalEditComponent>;
  _PointOfSaleA2Service_0_3:import5.PointOfSaleA2Service;
  _AdditionalService_0_4:import6.AdditionalService;
  _AdditionalValidationsService_0_5:import7.AdditionalValidationsService;
  _AdditionalEditComponent_0_6:Wrapper_AdditionalEditComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_AdditionalEditComponent_Host0,renderType_AdditionalEditComponent_Host,import8.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'additional-edit',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_AdditionalEditComponent0(this.viewUtils,this,0,this._el_0);
    this._PointOfSaleA2Service_0_3 = new import5.PointOfSaleA2Service(this.injectorGet(import11.Http,this.parentIndex));
    this._AdditionalService_0_4 = new import6.AdditionalService(this.injectorGet(import11.Http,this.parentIndex),this._PointOfSaleA2Service_0_3);
    this._AdditionalValidationsService_0_5 = new import7.AdditionalValidationsService();
    this._AdditionalEditComponent_0_6 = new Wrapper_AdditionalEditComponent(this.injectorGet(import12.NgZone,this.parentIndex),this._AdditionalService_0_4,this.injectorGet(import13.ActivatedRoute,this.parentIndex),this.injectorGet(import14.NotificationService,this.parentIndex),this.injectorGet(import15.Router,this.parentIndex),this.injectorGet(import16.LoadingWheelService,this.parentIndex),this.injectorGet(import17.FormBuilder,this.parentIndex),this._AdditionalValidationsService_0_5,this.injectorGet(import18.ModalService,this.parentIndex),this.injectorGet(import19.SessionService,this.parentIndex),this.injectorGet(import20.SidebarService,this.parentIndex),this.injectorGet(import14.NotificationService,this.parentIndex));
    this.compView_0.create(this._AdditionalEditComponent_0_6.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import10.ComponentRef_<any>(0,this,this._el_0,this._AdditionalEditComponent_0_6.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.PointOfSaleA2Service) && (0 === requestNodeIndex))) { return this._PointOfSaleA2Service_0_3; }
    if (((token === import6.AdditionalService) && (0 === requestNodeIndex))) { return this._AdditionalService_0_4; }
    if (((token === import7.AdditionalValidationsService) && (0 === requestNodeIndex))) { return this._AdditionalValidationsService_0_5; }
    if (((token === import0.AdditionalEditComponent) && (0 === requestNodeIndex))) { return this._AdditionalEditComponent_0_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._AdditionalEditComponent_0_6.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const AdditionalEditComponentNgFactory:import10.ComponentFactory<import0.AdditionalEditComponent> = new import10.ComponentFactory<import0.AdditionalEditComponent>('additional-edit',View_AdditionalEditComponent_Host0,import0.AdditionalEditComponent);
const styles_AdditionalEditComponent:any[] = ([] as any[]);
class View_AdditionalEditComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import21.CheckboxContainerComponent>;
  _CheckboxContainerComponent_2_3:import22.Wrapper_CheckboxContainerComponent;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  /*private*/ _expr_8:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_AdditionalEditComponent3,renderType_AdditionalEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_8 = import24.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-4 -md-6 -sm-12 -eva-3-pt-sm ellipsisText'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'checkbox-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import22.View_CheckboxContainerComponent0(this.viewUtils,this,2,this._el_2);
    this._CheckboxContainerComponent_2_3 = new import22.Wrapper_CheckboxContainerComponent();
    this.compView_2.create(this._CheckboxContainerComponent_2_3.context);
    this._text_3 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'dsp-tooltip',new import3.InlineArray2(2,'size','sm'),(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this._CheckboxContainerComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),false,true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import21.CheckboxContainerComponent) && (2 === requestNodeIndex))) { return this._CheckboxContainerComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = ('pos' + this.context.$implicit.oid);
    this._CheckboxContainerComponent_2_3.check_name(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this.context.$implicit.name;
    this._CheckboxContainerComponent_2_3.check_label(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = 'sm';
    this._CheckboxContainerComponent_2_3.check_size(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = this.parentView.parentView.parentView.context.isEditing;
    this._CheckboxContainerComponent_2_3.check_disabled(currVal_2_0_3,throwOnChange,false);
    const currVal_2_0_4:any = this.parentView.parentView.parentView.context.posSelected[this.context.$implicit.oid].checked;
    this._CheckboxContainerComponent_2_3.check_model(currVal_2_0_4,throwOnChange,false);
    this._CheckboxContainerComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_8:any = import3.inlineInterpolate(1,'',this.context.$implicit.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_8,currVal_8)) {
      this.renderer.setElementAttribute(this._el_4,'tooltip-text',((currVal_8 == null)? (null as any): currVal_8.toString()));
      this._expr_8 = currVal_8;
    }
    this.compView_2.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._CheckboxContainerComponent_2_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._CheckboxContainerComponent_2_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.parentView.context.posSelected[this.context.$implicit.oid].checked = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_AdditionalEditComponent5 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import25.RadioContainerComponent>;
  _RadioContainerComponent_2_3:import26.Wrapper_RadioContainerComponent;
  _text_3:any;
  _pipe_translate_0:import27.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_AdditionalEditComponent5,renderType_AdditionalEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-3 -md-6 -sm-12 -eva-3-pt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'radio-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import26.View_RadioContainerComponent0(this.viewUtils,this,2,this._el_2);
    this._RadioContainerComponent_2_3 = new import26.Wrapper_RadioContainerComponent();
    this.compView_2.create(this._RadioContainerComponent_2_3.context);
    this._text_3 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this._RadioContainerComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),false,true);
    this._pipe_translate_0 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.RadioContainerComponent) && (2 === requestNodeIndex))) { return this._RadioContainerComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import24.ValueUnwrapper();
    const currVal_2_0_0:any = this.context.$implicit.code;
    this._RadioContainerComponent_2_3.check_id(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this.context.$implicit.code;
    this._RadioContainerComponent_2_3.check_value(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = 'additionalRadio';
    this._RadioContainerComponent_2_3.check_name(currVal_2_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_2_0_3:any = valUnwrapper.unwrap(this._pipe_translate_0.transform(('additionalPrice.additional.' + this.context.$implicit.code)));
    this._RadioContainerComponent_2_3.check_label(currVal_2_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_2_0_4:any = this.parentView.parentView.parentView.parentView.context.isEditing;
    this._RadioContainerComponent_2_3.check_disabled(currVal_2_0_4,throwOnChange,false);
    const currVal_2_0_5:any = this.parentView.parentView.parentView.parentView.context.additionalSelected.addSelected;
    this._RadioContainerComponent_2_3.check_model(currVal_2_0_5,throwOnChange,false);
    this._RadioContainerComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._RadioContainerComponent_2_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._RadioContainerComponent_2_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.parentView.parentView.context.additionalSelected.addSelected = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_AdditionalEditComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import23.ViewContainer;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import29.Wrapper_NgFor;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_AdditionalEditComponent4,renderType_AdditionalEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import23.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import30.TemplateRef_(this,2,this._anchor_2);
    this._NgFor_2_6 = new import29.Wrapper_NgFor(this._vc_2.vcRef,this._TemplateRef_2_5,this.parentView.parentView.parentView.parentView.injectorGet(import31.IterableDiffers,this.parentView.parentView.parentView.parentIndex),this.parentView.parentView.parentView.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import30.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import32.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.parentView.parentView.context.notEnsuredAdditionals;
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,false);
    this._NgFor_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_AdditionalEditComponent5(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
}
class View_AdditionalEditComponent7 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import25.RadioContainerComponent>;
  _RadioContainerComponent_2_3:import26.Wrapper_RadioContainerComponent;
  _text_3:any;
  _text_4:any;
  _pipe_translate_0:import27.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_AdditionalEditComponent7,renderType_AdditionalEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-3 -md-6 -sm-12 -eva-3-pt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'radio-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import26.View_RadioContainerComponent0(this.viewUtils,this,2,this._el_2);
    this._RadioContainerComponent_2_3 = new import26.Wrapper_RadioContainerComponent();
    this._text_3 = this.renderer.createText((null as any),'\n                                    ',(null as any));
    this.compView_2.create(this._RadioContainerComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_2));
    this._RadioContainerComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),false,true);
    this._pipe_translate_0 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.RadioContainerComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._RadioContainerComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import24.ValueUnwrapper();
    const currVal_2_0_0:any = this.context.$implicit.code;
    this._RadioContainerComponent_2_3.check_id(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this.context.$implicit.code;
    this._RadioContainerComponent_2_3.check_value(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = 'additionalRadio';
    this._RadioContainerComponent_2_3.check_name(currVal_2_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_2_0_3:any = valUnwrapper.unwrap(this._pipe_translate_0.transform(('additionalPrice.additional.' + this.context.$implicit.code)));
    this._RadioContainerComponent_2_3.check_label(currVal_2_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_2_0_4:any = this.parentView.parentView.parentView.parentView.context.isEditing;
    this._RadioContainerComponent_2_3.check_disabled(currVal_2_0_4,throwOnChange,false);
    const currVal_2_0_5:any = this.parentView.parentView.parentView.parentView.context.additionalSelected.addSelected;
    this._RadioContainerComponent_2_3.check_model(currVal_2_0_5,throwOnChange,false);
    this._RadioContainerComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._RadioContainerComponent_2_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._RadioContainerComponent_2_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.parentView.parentView.context.additionalSelected.addSelected = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>(this.parentView.parentView.parentView.parentView.context.included = false)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_AdditionalEditComponent8 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import25.RadioContainerComponent>;
  _RadioContainerComponent_2_3:import26.Wrapper_RadioContainerComponent;
  _text_3:any;
  _text_4:any;
  _pipe_translate_0:import27.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_AdditionalEditComponent8,renderType_AdditionalEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-3 -md-6 -sm-12 -eva-3-pt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'radio-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import26.View_RadioContainerComponent0(this.viewUtils,this,2,this._el_2);
    this._RadioContainerComponent_2_3 = new import26.Wrapper_RadioContainerComponent();
    this._text_3 = this.renderer.createText((null as any),'\n                                    ',(null as any));
    this.compView_2.create(this._RadioContainerComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray4(4,'change',(null as any),'modelChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this._RadioContainerComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),false,true);
    this._pipe_translate_0 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.RadioContainerComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._RadioContainerComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import24.ValueUnwrapper();
    const currVal_2_0_0:any = 'TOLL';
    this._RadioContainerComponent_2_3.check_id(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = 'TOLL';
    this._RadioContainerComponent_2_3.check_value(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = 'additionalRadio';
    this._RadioContainerComponent_2_3.check_name(currVal_2_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_2_0_3:any = valUnwrapper.unwrap(this._pipe_translate_0.transform('additionalPrice.toll.TOLL_SYSTEM'));
    this._RadioContainerComponent_2_3.check_label(currVal_2_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_2_0_4:any = this.parentView.parentView.parentView.parentView.context.isEditing;
    this._RadioContainerComponent_2_3.check_disabled(currVal_2_0_4,throwOnChange,false);
    const currVal_2_0_5:any = this.parentView.parentView.parentView.parentView.context.additionalSelected.addSelected;
    this._RadioContainerComponent_2_3.check_model(currVal_2_0_5,throwOnChange,false);
    this._RadioContainerComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._RadioContainerComponent_2_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._RadioContainerComponent_2_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'change')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.parentView.parentView.context.cleanTollConfiguration()) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'modelChange')) {
      const pd_sub_1:any = ((<any>(this.parentView.parentView.parentView.parentView.context.additionalSelected.addSelected = $event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_AdditionalEditComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import23.ViewContainer;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import29.Wrapper_NgFor;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _vc_4:import23.ViewContainer;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import33.Wrapper_NgIf;
  _text_5:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_AdditionalEditComponent6,renderType_AdditionalEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n\n                                ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import23.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import30.TemplateRef_(this,2,this._anchor_2);
    this._NgFor_2_6 = new import29.Wrapper_NgFor(this._vc_2.vcRef,this._TemplateRef_2_5,this.parentView.parentView.parentView.parentView.injectorGet(import31.IterableDiffers,this.parentView.parentView.parentView.parentIndex),this.parentView.parentView.parentView.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_4 = new import23.ViewContainer(4,0,this,this._anchor_4);
    this._TemplateRef_4_5 = new import30.TemplateRef_(this,4,this._anchor_4);
    this._NgIf_4_6 = new import33.Wrapper_NgIf(this._vc_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._anchor_4,
      this._text_5
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import30.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import32.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    if (((token === import30.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import34.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.parentView.parentView.context.ensuredAdditionals;
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,false);
    this._NgFor_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    const currVal_4_0_0:any = (this.parentView.parentView.parentView.context.getCountryCode() == '20208');
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.ngDoCheck(this,this._anchor_4,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    this._vc_4.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this._vc_4.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_AdditionalEditComponent7(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    if ((nodeIndex == 4)) { return new View_AdditionalEditComponent8(this.viewUtils,this,4,this._anchor_4,this._vc_4); }
    return (null as any);
  }
}
class View_AdditionalEditComponent9 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import21.CheckboxContainerComponent>;
  _CheckboxContainerComponent_2_3:import22.Wrapper_CheckboxContainerComponent;
  _text_3:any;
  _text_4:any;
  _pipe_translate_0:import27.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_AdditionalEditComponent9,renderType_AdditionalEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-3 -md-6 -sm-12 -eva-3-pt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'checkbox-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import22.View_CheckboxContainerComponent0(this.viewUtils,this,2,this._el_2);
    this._CheckboxContainerComponent_2_3 = new import22.Wrapper_CheckboxContainerComponent();
    this._text_3 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this.compView_2.create(this._CheckboxContainerComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_2));
    this._CheckboxContainerComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),false,true);
    this._pipe_translate_0 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import21.CheckboxContainerComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._CheckboxContainerComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import24.ValueUnwrapper();
    const currVal_2_0_0:any = 'included';
    this._CheckboxContainerComponent_2_3.check_name(currVal_2_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_2_0_1:any = valUnwrapper.unwrap(this._pipe_translate_0.transform('additionalPrice.INCLUDE'));
    this._CheckboxContainerComponent_2_3.check_label(currVal_2_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_2_0_2:any = 'sm';
    this._CheckboxContainerComponent_2_3.check_size(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = false;
    this._CheckboxContainerComponent_2_3.check_disabled(currVal_2_0_3,throwOnChange,false);
    const currVal_2_0_4:any = this.parentView.parentView.parentView.context.included;
    this._CheckboxContainerComponent_2_3.check_model(currVal_2_0_4,throwOnChange,false);
    this._CheckboxContainerComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._CheckboxContainerComponent_2_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._CheckboxContainerComponent_2_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.parentView.context.included = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.parentView.parentView.parentView.context.resetBaseAmount()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_AdditionalEditComponent11 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  compView_14:import1.AppView<import35.InputContainerComponent>;
  _InputContainerComponent_14_3:import36.Wrapper_InputContainerComponent;
  _text_15:any;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _el_27:any;
  _el_28:any;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  /*private*/ _expr_34:any;
  _pipe_translate_0:import27.TranslatePipe;
  _pipe_translate_1:import27.TranslatePipe;
  /*private*/ _expr_37:any;
  /*private*/ _expr_38:any;
  _pipe_translate_2:import27.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_AdditionalEditComponent11,renderType_AdditionalEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_34 = import24.UNINITIALIZED;
    this._expr_37 = import24.UNINITIALIZED;
    this._expr_38 = import24.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-lg'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md -eva-3-pb-sm'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                                        ',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-3 -md-6 -sm-12'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                                            ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','content eva-3-validation -top-left'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                                                ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','eva-3-input -md -icon-right'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                                                    ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_12,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_14 = new import36.View_InputContainerComponent0(this.viewUtils,this,14,this._el_14);
    this._InputContainerComponent_14_3 = new import36.Wrapper_InputContainerComponent();
    this.compView_14.create(this._InputContainerComponent_14_3.context);
    this._text_15 = this.renderer.createText(this._el_12,'\n                                                ',(null as any));
    this._text_16 = this.renderer.createText(this._el_10,'\n                                            ',(null as any));
    this._text_17 = this.renderer.createText(this._el_8,'\n                                        ',(null as any));
    this._text_18 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-1 -md-1 -sm-2 -eva-3-pl-xsm -eva-3-mt-lg'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'\n                                            ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_19,'span',new import3.InlineArray2(2,'class','percentage-label'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'',(null as any));
    this._text_23 = this.renderer.createText(this._el_19,'\n                                        ',(null as any));
    this._text_24 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-6 -md-12 -sm-12 -eva-3-mt-lg'),(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'\n                                            ',(null as any));
    this._el_27 = import3.createRenderElement(this.renderer,this._el_25,'span',new import3.InlineArray2(2,'class','eva-3-p information-box alert-info'),(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_27,'i',new import3.InlineArray2(2,'class','fa fa-info'),(null as any));
    this._text_29 = this.renderer.createText(this._el_27,'',(null as any));
    this._text_30 = this.renderer.createText(this._el_25,'\n                                        ',(null as any));
    this._text_31 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._pipe_translate_0 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_14,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_14));
    this._InputContainerComponent_14_3.subscribe(this,this.eventHandler(this.handleEvent_14),false,false,true);
    this._pipe_translate_1 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this._pipe_translate_2 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._el_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._text_31
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import35.InputContainerComponent) && (14 === requestNodeIndex))) { return this._InputContainerComponent_14_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import24.ValueUnwrapper();
    const currVal_14_0_0:any = 0;
    this._InputContainerComponent_14_3.check_placeholder(currVal_14_0_0,throwOnChange,false);
    const currVal_14_0_1:any = 'limitedTollBaseAmount';
    this._InputContainerComponent_14_3.check_name(currVal_14_0_1,throwOnChange,false);
    const currVal_14_0_2:boolean = !!this.parentView.parentView.parentView.parentView.context.errors['limitedTollBaseAmount'];
    this._InputContainerComponent_14_3.check_invalid(currVal_14_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_14_0_3:any = valUnwrapper.unwrap(this._pipe_translate_1.transform(this.parentView.parentView.parentView.parentView.context.errorMessages['limitedTollBaseAmount']));
    this._InputContainerComponent_14_3.check_invalidText(currVal_14_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_14_0_4:any = this.parentView.parentView.parentView.parentView.context.toll.baseAmount;
    this._InputContainerComponent_14_3.check_model(currVal_14_0_4,throwOnChange,false);
    this._InputContainerComponent_14_3.ngDoCheck(this,this._el_14,throwOnChange);
    valUnwrapper.reset();
    const currVal_34:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform((('additionalPrice.toll.LIMITED_TOLL_INFO_' + this.parentView.context.$implicit.code) + '_IMPORT'))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_34,currVal_34))) {
      this.renderer.setText(this._text_5,currVal_34);
      this._expr_34 = currVal_34;
    }
    const currVal_37:any = import3.inlineInterpolate(1,'',this.parentView.parentView.parentView.parentView.context.getCurrencyCode(),'');
    if (import3.checkBinding(throwOnChange,this._expr_37,currVal_37)) {
      this.renderer.setText(this._text_22,currVal_37);
      this._expr_37 = currVal_37;
    }
    valUnwrapper.reset();
    const currVal_38:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_2.transform('additionalPrice.toll.MAX_INFO')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_38,currVal_38))) {
      this.renderer.setText(this._text_29,currVal_38);
      this._expr_38 = currVal_38;
    }
    this.compView_14.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._InputContainerComponent_14_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_14.destroy();
    this._InputContainerComponent_14_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_14(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.parentView.parentView.context.toll.baseAmount = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_AdditionalEditComponent10 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  compView_6:import1.AppView<import25.RadioContainerComponent>;
  _RadioContainerComponent_6_3:import26.Wrapper_RadioContainerComponent;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _anchor_11:any;
  /*private*/ _vc_11:import23.ViewContainer;
  _TemplateRef_11_5:any;
  _NgIf_11_6:import33.Wrapper_NgIf;
  _text_12:any;
  _pipe_translate_0:import27.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_AdditionalEditComponent10,renderType_AdditionalEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-lg -eva-3-mb-md'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'radio-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_6 = new import26.View_RadioContainerComponent0(this.viewUtils,this,6,this._el_6);
    this._RadioContainerComponent_6_3 = new import26.Wrapper_RadioContainerComponent();
    this._text_7 = this.renderer.createText((null as any),'\n                                            ',(null as any));
    this.compView_6.create(this._RadioContainerComponent_6_3.context);
    this._text_8 = this.renderer.createText(this._el_4,'\n                                        ',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n                                    ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._anchor_11 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_11 = new import23.ViewContainer(11,0,this,this._anchor_11);
    this._TemplateRef_11_5 = new import30.TemplateRef_(this,11,this._anchor_11);
    this._NgIf_11_6 = new import33.Wrapper_NgIf(this._vc_11.vcRef,this._TemplateRef_11_5);
    this._text_12 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_6,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_6));
    this._RadioContainerComponent_6_3.subscribe(this,this.eventHandler(this.handleEvent_6),false,true);
    this._pipe_translate_0 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._anchor_11,
      this._text_12
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.RadioContainerComponent) && ((6 <= requestNodeIndex) && (requestNodeIndex <= 7)))) { return this._RadioContainerComponent_6_3.context; }
    if (((token === import30.TemplateRef) && (11 === requestNodeIndex))) { return this._TemplateRef_11_5; }
    if (((token === import34.NgIf) && (11 === requestNodeIndex))) { return this._NgIf_11_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import24.ValueUnwrapper();
    const currVal_6_0_0:any = this.context.$implicit.code;
    this._RadioContainerComponent_6_3.check_id(currVal_6_0_0,throwOnChange,false);
    const currVal_6_0_1:any = this.context.$implicit.code;
    this._RadioContainerComponent_6_3.check_value(currVal_6_0_1,throwOnChange,false);
    const currVal_6_0_2:any = 'toll';
    this._RadioContainerComponent_6_3.check_name(currVal_6_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_6_0_3:any = valUnwrapper.unwrap(this._pipe_translate_0.transform(('additionalPrice.toll.LIMITED_TOLL_INFO_' + this.context.$implicit.code)));
    this._RadioContainerComponent_6_3.check_label(currVal_6_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_6_0_4:any = this.parentView.parentView.parentView.context.toll.addSelected;
    this._RadioContainerComponent_6_3.check_model(currVal_6_0_4,throwOnChange,false);
    this._RadioContainerComponent_6_3.ngDoCheck(this,this._el_6,throwOnChange);
    const currVal_11_0_0:any = (this.parentView.parentView.parentView.context.toll.addSelected === this.context.$implicit.code);
    this._NgIf_11_6.check_ngIf(currVal_11_0_0,throwOnChange,false);
    this._NgIf_11_6.ngDoCheck(this,this._anchor_11,throwOnChange);
    this._vc_11.detectChangesInNestedViews(throwOnChange);
    this.compView_6.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._RadioContainerComponent_6_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this._vc_11.destroyNestedViews();
    this.compView_6.destroy();
    this._RadioContainerComponent_6_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 11)) { return new View_AdditionalEditComponent11(this.viewUtils,this,11,this._anchor_11,this._vc_11); }
    return (null as any);
  }
  handleEvent_6(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.parentView.context.toll.addSelected = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>(this.parentView.parentView.parentView.context.toll.baseAmount = 0)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_AdditionalEditComponent2 extends import1.AppView<any> {
  _el_0:any;
  _NgForm_0_3:import37.Wrapper_NgForm;
  _ControlContainer_0_4:any;
  _NgControlStatusGroup_0_5:import38.Wrapper_NgControlStatusGroup;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _NgClass_16_3:import39.Wrapper_NgClass;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _text_26:any;
  _el_27:any;
  _text_28:any;
  _el_29:any;
  _text_30:any;
  _el_31:any;
  _text_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _text_36:any;
  _text_37:any;
  _text_38:any;
  _text_39:any;
  _text_40:any;
  _el_41:any;
  _text_42:any;
  _anchor_43:any;
  /*private*/ _vc_43:import23.ViewContainer;
  _TemplateRef_43_5:any;
  _NgFor_43_6:import29.Wrapper_NgFor;
  _text_44:any;
  _text_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _text_49:any;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _el_53:any;
  _text_54:any;
  _el_55:any;
  _NgClass_55_3:import39.Wrapper_NgClass;
  _text_56:any;
  _el_57:any;
  _text_58:any;
  _el_59:any;
  _text_60:any;
  _el_61:any;
  _text_62:any;
  _el_63:any;
  _text_64:any;
  _text_65:any;
  _text_66:any;
  _text_67:any;
  _el_68:any;
  _text_69:any;
  _el_70:any;
  _text_71:any;
  _el_72:any;
  _text_73:any;
  _el_74:any;
  _text_75:any;
  _text_76:any;
  _text_77:any;
  _text_78:any;
  _text_79:any;
  _anchor_80:any;
  /*private*/ _vc_80:import23.ViewContainer;
  _TemplateRef_80_5:any;
  _NgIf_80_6:import33.Wrapper_NgIf;
  _text_81:any;
  _text_82:any;
  _el_83:any;
  _text_84:any;
  _text_85:any;
  _text_86:any;
  _text_87:any;
  _text_88:any;
  _el_89:any;
  _text_90:any;
  _el_91:any;
  _NgClass_91_3:import39.Wrapper_NgClass;
  _text_92:any;
  _el_93:any;
  _text_94:any;
  _el_95:any;
  _text_96:any;
  _el_97:any;
  _text_98:any;
  _el_99:any;
  _text_100:any;
  _text_101:any;
  _text_102:any;
  _text_103:any;
  _el_104:any;
  _text_105:any;
  _el_106:any;
  _text_107:any;
  _el_108:any;
  _text_109:any;
  _el_110:any;
  _text_111:any;
  _text_112:any;
  _text_113:any;
  _text_114:any;
  _text_115:any;
  _anchor_116:any;
  /*private*/ _vc_116:import23.ViewContainer;
  _TemplateRef_116_5:any;
  _NgIf_116_6:import33.Wrapper_NgIf;
  _text_117:any;
  _text_118:any;
  _el_119:any;
  _text_120:any;
  _text_121:any;
  _text_122:any;
  _text_123:any;
  _text_124:any;
  _el_125:any;
  _text_126:any;
  _el_127:any;
  _text_128:any;
  _el_129:any;
  _text_130:any;
  _el_131:any;
  _text_132:any;
  _el_133:any;
  _text_134:any;
  _text_135:any;
  _text_136:any;
  _text_137:any;
  _el_138:any;
  _text_139:any;
  _el_140:any;
  _text_141:any;
  _el_142:any;
  _text_143:any;
  _el_144:any;
  _text_145:any;
  _el_146:any;
  compView_146:import1.AppView<import35.InputContainerComponent>;
  _InputContainerComponent_146_3:import36.Wrapper_InputContainerComponent;
  _text_147:any;
  _text_148:any;
  _text_149:any;
  _text_150:any;
  _text_151:any;
  _el_152:any;
  _text_153:any;
  _el_154:any;
  _text_155:any;
  _text_156:any;
  _text_157:any;
  _anchor_158:any;
  /*private*/ _vc_158:import23.ViewContainer;
  _TemplateRef_158_5:any;
  _NgIf_158_6:import33.Wrapper_NgIf;
  _text_159:any;
  _text_160:any;
  _text_161:any;
  _text_162:any;
  _el_163:any;
  _text_164:any;
  _el_165:any;
  _text_166:any;
  _el_167:any;
  _text_168:any;
  _el_169:any;
  _text_170:any;
  _el_171:any;
  _text_172:any;
  _text_173:any;
  _el_174:any;
  _text_175:any;
  _text_176:any;
  _text_177:any;
  _text_178:any;
  _el_179:any;
  _NgClass_179_3:import39.Wrapper_NgClass;
  _text_180:any;
  _el_181:any;
  _text_182:any;
  _el_183:any;
  _text_184:any;
  _el_185:any;
  compView_185:import1.AppView<import21.CheckboxContainerComponent>;
  _CheckboxContainerComponent_185_3:import22.Wrapper_CheckboxContainerComponent;
  _text_186:any;
  _text_187:any;
  _el_188:any;
  _text_189:any;
  _text_190:any;
  _text_191:any;
  _text_192:any;
  _el_193:any;
  _text_194:any;
  _el_195:any;
  _text_196:any;
  _el_197:any;
  _text_198:any;
  _el_199:any;
  _text_200:any;
  _text_201:any;
  _text_202:any;
  _text_203:any;
  _el_204:any;
  _text_205:any;
  _el_206:any;
  _text_207:any;
  _el_208:any;
  _text_209:any;
  _text_210:any;
  _text_211:any;
  _el_212:any;
  _text_213:any;
  _el_214:any;
  _text_215:any;
  _el_216:any;
  _text_217:any;
  _el_218:any;
  compView_218:import1.AppView<import35.InputContainerComponent>;
  _InputContainerComponent_218_3:import36.Wrapper_InputContainerComponent;
  _text_219:any;
  _text_220:any;
  _text_221:any;
  _text_222:any;
  _el_223:any;
  _text_224:any;
  _el_225:any;
  _text_226:any;
  _text_227:any;
  _text_228:any;
  _el_229:any;
  _text_230:any;
  _el_231:any;
  _el_232:any;
  _text_233:any;
  _text_234:any;
  _text_235:any;
  _text_236:any;
  _el_237:any;
  _text_238:any;
  _el_239:any;
  _text_240:any;
  _el_241:any;
  _text_242:any;
  _text_243:any;
  _text_244:any;
  _text_245:any;
  _el_246:any;
  _text_247:any;
  _el_248:any;
  _text_249:any;
  _el_250:any;
  compView_250:import1.AppView<import25.RadioContainerComponent>;
  _RadioContainerComponent_250_3:import26.Wrapper_RadioContainerComponent;
  _text_251:any;
  _text_252:any;
  _text_253:any;
  _text_254:any;
  _el_255:any;
  _text_256:any;
  _el_257:any;
  _text_258:any;
  _el_259:any;
  compView_259:import1.AppView<import25.RadioContainerComponent>;
  _RadioContainerComponent_259_3:import26.Wrapper_RadioContainerComponent;
  _text_260:any;
  _text_261:any;
  _text_262:any;
  _text_263:any;
  _text_264:any;
  _el_265:any;
  _text_266:any;
  _el_267:any;
  _text_268:any;
  _el_269:any;
  compView_269:import1.AppView<import21.CheckboxContainerComponent>;
  _CheckboxContainerComponent_269_3:import22.Wrapper_CheckboxContainerComponent;
  _text_270:any;
  _text_271:any;
  _el_272:any;
  _text_273:any;
  _text_274:any;
  _text_275:any;
  _text_276:any;
  _el_277:any;
  _text_278:any;
  _el_279:any;
  _text_280:any;
  _el_281:any;
  _text_282:any;
  _el_283:any;
  _text_284:any;
  _text_285:any;
  _text_286:any;
  _text_287:any;
  _anchor_288:any;
  /*private*/ _vc_288:import23.ViewContainer;
  _TemplateRef_288_5:any;
  _NgFor_288_6:import29.Wrapper_NgFor;
  _text_289:any;
  _text_290:any;
  _el_291:any;
  _text_292:any;
  _text_293:any;
  _text_294:any;
  _text_295:any;
  _text_296:any;
  _el_297:any;
  _text_298:any;
  _el_299:any;
  _text_300:any;
  _el_301:any;
  _text_302:any;
  _el_303:any;
  _text_304:any;
  _text_305:any;
  _el_306:any;
  _text_307:any;
  _text_308:any;
  _text_309:any;
  _text_310:any;
  _text_311:any;
  _text_312:any;
  /*private*/ _expr_347:any;
  _pipe_translate_0:import27.TranslatePipe;
  _map_349:any;
  /*private*/ _expr_350:any;
  _pipe_translate_1:import27.TranslatePipe;
  /*private*/ _expr_352:any;
  /*private*/ _expr_353:any;
  _pipe_translate_2:import27.TranslatePipe;
  /*private*/ _expr_355:any;
  _pipe_translate_3:import27.TranslatePipe;
  /*private*/ _expr_357:any;
  _pipe_translate_4:import27.TranslatePipe;
  _map_359:any;
  /*private*/ _expr_360:any;
  _pipe_translate_5:import27.TranslatePipe;
  /*private*/ _expr_362:any;
  _pipe_translate_6:import27.TranslatePipe;
  /*private*/ _expr_364:any;
  _pipe_translate_7:import27.TranslatePipe;
  _map_366:any;
  /*private*/ _expr_367:any;
  _pipe_translate_8:import27.TranslatePipe;
  /*private*/ _expr_369:any;
  _pipe_translate_9:import27.TranslatePipe;
  /*private*/ _expr_371:any;
  _pipe_translate_10:import27.TranslatePipe;
  /*private*/ _expr_373:any;
  /*private*/ _expr_374:any;
  _pipe_translate_11:import27.TranslatePipe;
  _pipe_translate_12:import27.TranslatePipe;
  /*private*/ _expr_377:any;
  /*private*/ _expr_378:any;
  /*private*/ _expr_379:any;
  _pipe_translate_13:import27.TranslatePipe;
  /*private*/ _expr_381:any;
  _pipe_translate_14:import27.TranslatePipe;
  _map_383:any;
  /*private*/ _expr_384:any;
  _pipe_translate_15:import27.TranslatePipe;
  /*private*/ _expr_386:any;
  /*private*/ _expr_387:any;
  _pipe_translate_16:import27.TranslatePipe;
  /*private*/ _expr_389:any;
  _pipe_translate_17:import27.TranslatePipe;
  _pipe_translate_18:import27.TranslatePipe;
  /*private*/ _expr_392:any;
  /*private*/ _expr_393:any;
  _pipe_translate_19:import27.TranslatePipe;
  /*private*/ _expr_395:any;
  _pipe_translate_20:import27.TranslatePipe;
  _pipe_translate_21:import27.TranslatePipe;
  _pipe_translate_22:import27.TranslatePipe;
  /*private*/ _expr_399:any;
  _pipe_translate_23:import27.TranslatePipe;
  /*private*/ _expr_401:any;
  /*private*/ _expr_402:any;
  _pipe_translate_24:import27.TranslatePipe;
  /*private*/ _expr_404:any;
  _pipe_translate_25:import27.TranslatePipe;
  /*private*/ _expr_406:any;
  _pipe_translate_26:import27.TranslatePipe;
  /*private*/ _expr_408:any;
  _pipe_translate_27:import27.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_AdditionalEditComponent2,renderType_AdditionalEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_347 = import24.UNINITIALIZED;
    this._map_349 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-invalid': p0};
    });
    this._expr_350 = import24.UNINITIALIZED;
    this._expr_352 = import24.UNINITIALIZED;
    this._expr_353 = import24.UNINITIALIZED;
    this._expr_355 = import24.UNINITIALIZED;
    this._expr_357 = import24.UNINITIALIZED;
    this._map_359 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-invalid': p0};
    });
    this._expr_360 = import24.UNINITIALIZED;
    this._expr_362 = import24.UNINITIALIZED;
    this._expr_364 = import24.UNINITIALIZED;
    this._map_366 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-invalid': p0};
    });
    this._expr_367 = import24.UNINITIALIZED;
    this._expr_369 = import24.UNINITIALIZED;
    this._expr_371 = import24.UNINITIALIZED;
    this._expr_373 = import24.UNINITIALIZED;
    this._expr_374 = import24.UNINITIALIZED;
    this._expr_377 = import24.UNINITIALIZED;
    this._expr_378 = import24.UNINITIALIZED;
    this._expr_379 = import24.UNINITIALIZED;
    this._expr_381 = import24.UNINITIALIZED;
    this._map_383 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-invalid': p0};
    });
    this._expr_384 = import24.UNINITIALIZED;
    this._expr_386 = import24.UNINITIALIZED;
    this._expr_387 = import24.UNINITIALIZED;
    this._expr_389 = import24.UNINITIALIZED;
    this._expr_392 = import24.UNINITIALIZED;
    this._expr_393 = import24.UNINITIALIZED;
    this._expr_395 = import24.UNINITIALIZED;
    this._expr_399 = import24.UNINITIALIZED;
    this._expr_401 = import24.UNINITIALIZED;
    this._expr_402 = import24.UNINITIALIZED;
    this._expr_404 = import24.UNINITIALIZED;
    this._expr_406 = import24.UNINITIALIZED;
    this._expr_408 = import24.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'form',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._NgForm_0_3 = new import37.Wrapper_NgForm((null as any),(null as any));
    this._ControlContainer_0_4 = this._NgForm_0_3.context;
    this._NgControlStatusGroup_0_5 = new import38.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
    this._text_1 = this.renderer.createText(this._el_0,'\n\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-container eva3-restyle'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                        ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'h2',new import3.InlineArray2(2,'class','eva-3-h2 -eva-3-pb-md'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'\n                    ',(null as any));
    this._text_11 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._text_12 = this.renderer.createText(this._el_2,'\n\n                ',(null as any));
    this._text_13 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n                    ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_14,'div',new import3.InlineArray4(4,'class','eva-3-validation -lg -top-left','qadata','branchOffices'),(null as any));
    this._NgClass_16_3 = new import39.Wrapper_NgClass(this.parentView.parentView.parentView.injectorGet(import31.IterableDiffers,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import40.KeyValueDiffers,this.parentView.parentView.parentIndex),new import41.ElementRef(this._el_16),this.renderer);
    this._text_17 = this.renderer.createText(this._el_16,'\n\n                        ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_16,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n\n                            ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_18,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n                                ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_20,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'\n                                    ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_22,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'',(null as any));
    this._text_26 = this.renderer.createText(this._el_22,'\n                                    ',(null as any));
    this._el_27 = import3.createRenderElement(this.renderer,this._el_22,'div',new import3.InlineArray2(2,'class','all-none-links oneWaySearchBox'),(null as any));
    this._text_28 = this.renderer.createText(this._el_27,'\n                                        ',(null as any));
    this._el_29 = import3.createRenderElement(this.renderer,this._el_27,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_30 = this.renderer.createText(this._el_29,'\n                                            ',(null as any));
    this._el_31 = import3.createRenderElement(this.renderer,this._el_29,'a',new import3.InlineArray4(4,'class','eva-3-link message-link','name','allPos'),(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'',(null as any));
    this._text_33 = this.renderer.createText(this._el_29,' |\n                                            ',(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_29,'a',new import3.InlineArray4(4,'class','eva-3-link message-link','name','nonePos'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'',(null as any));
    this._text_36 = this.renderer.createText(this._el_29,'\n                                        ',(null as any));
    this._text_37 = this.renderer.createText(this._el_27,'\n                                    ',(null as any));
    this._text_38 = this.renderer.createText(this._el_22,'\n                                ',(null as any));
    this._text_39 = this.renderer.createText(this._el_20,'\n                            ',(null as any));
    this._text_40 = this.renderer.createText(this._el_18,'\n                            ',(null as any));
    this._el_41 = import3.createRenderElement(this.renderer,this._el_18,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_42 = this.renderer.createText(this._el_41,'\n                                ',(null as any));
    this._anchor_43 = this.renderer.createTemplateAnchor(this._el_41,(null as any));
    this._vc_43 = new import23.ViewContainer(43,41,this,this._anchor_43);
    this._TemplateRef_43_5 = new import30.TemplateRef_(this,43,this._anchor_43);
    this._NgFor_43_6 = new import29.Wrapper_NgFor(this._vc_43.vcRef,this._TemplateRef_43_5,this.parentView.parentView.parentView.injectorGet(import31.IterableDiffers,this.parentView.parentView.parentIndex),this.parentView.parentView.ref);
    this._text_44 = this.renderer.createText(this._el_41,'\n                            ',(null as any));
    this._text_45 = this.renderer.createText(this._el_18,'\n                        ',(null as any));
    this._text_46 = this.renderer.createText(this._el_16,'\n                        ',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,this._el_16,'span',new import3.InlineArray2(2,'class','validation-msg'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'',(null as any));
    this._text_49 = this.renderer.createText(this._el_16,'\n\n                    ',(null as any));
    this._text_50 = this.renderer.createText(this._el_14,'\n                ',(null as any));
    this._text_51 = this.renderer.createText(this._el_2,'\n\n                ',(null as any));
    this._text_52 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_53 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_54 = this.renderer.createText(this._el_53,'\n                    ',(null as any));
    this._el_55 = import3.createRenderElement(this.renderer,this._el_53,'div',new import3.InlineArray4(4,'class','eva-3-validation -lg -top-left','qadata','additionalRadioError'),(null as any));
    this._NgClass_55_3 = new import39.Wrapper_NgClass(this.parentView.parentView.parentView.injectorGet(import31.IterableDiffers,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import40.KeyValueDiffers,this.parentView.parentView.parentIndex),new import41.ElementRef(this._el_55),this.renderer);
    this._text_56 = this.renderer.createText(this._el_55,'\n\n                        ',(null as any));
    this._el_57 = import3.createRenderElement(this.renderer,this._el_55,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_58 = this.renderer.createText(this._el_57,'\n                            ',(null as any));
    this._el_59 = import3.createRenderElement(this.renderer,this._el_57,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_60 = this.renderer.createText(this._el_59,'\n                                ',(null as any));
    this._el_61 = import3.createRenderElement(this.renderer,this._el_59,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_62 = this.renderer.createText(this._el_61,'\n                                    ',(null as any));
    this._el_63 = import3.createRenderElement(this.renderer,this._el_61,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_64 = this.renderer.createText(this._el_63,'',(null as any));
    this._text_65 = this.renderer.createText(this._el_61,'\n                                ',(null as any));
    this._text_66 = this.renderer.createText(this._el_59,'\n                            ',(null as any));
    this._text_67 = this.renderer.createText(this._el_57,'\n\n                            ',(null as any));
    this._el_68 = import3.createRenderElement(this.renderer,this._el_57,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_69 = this.renderer.createText(this._el_68,'\n                                ',(null as any));
    this._el_70 = import3.createRenderElement(this.renderer,this._el_68,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_71 = this.renderer.createText(this._el_70,'\n                                    ',(null as any));
    this._el_72 = import3.createRenderElement(this.renderer,this._el_70,'dsp-message',new import3.InlineArray2(2,'closable','false'),(null as any));
    this._text_73 = this.renderer.createText(this._el_72,'\n                                        ',(null as any));
    this._el_74 = import3.createRenderElement(this.renderer,this._el_72,'p',new import3.InlineArray2(2,'class','eva-3-p message-text -eva-3-pt-sm'),(null as any));
    this._text_75 = this.renderer.createText(this._el_74,'',(null as any));
    this._text_76 = this.renderer.createText(this._el_72,'\n                                    ',(null as any));
    this._text_77 = this.renderer.createText(this._el_70,'\n                                ',(null as any));
    this._text_78 = this.renderer.createText(this._el_68,'\n                            ',(null as any));
    this._text_79 = this.renderer.createText(this._el_57,'\n\n                            ',(null as any));
    this._anchor_80 = this.renderer.createTemplateAnchor(this._el_57,(null as any));
    this._vc_80 = new import23.ViewContainer(80,57,this,this._anchor_80);
    this._TemplateRef_80_5 = new import30.TemplateRef_(this,80,this._anchor_80);
    this._NgIf_80_6 = new import33.Wrapper_NgIf(this._vc_80.vcRef,this._TemplateRef_80_5);
    this._text_81 = this.renderer.createText(this._el_57,'\n                        ',(null as any));
    this._text_82 = this.renderer.createText(this._el_55,'\n                        ',(null as any));
    this._el_83 = import3.createRenderElement(this.renderer,this._el_55,'span',new import3.InlineArray2(2,'class','validation-msg'),(null as any));
    this._text_84 = this.renderer.createText(this._el_83,'',(null as any));
    this._text_85 = this.renderer.createText(this._el_55,'\n\n                    ',(null as any));
    this._text_86 = this.renderer.createText(this._el_53,'\n                ',(null as any));
    this._text_87 = this.renderer.createText(this._el_2,'\n\n                ',(null as any));
    this._text_88 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_89 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_90 = this.renderer.createText(this._el_89,'\n                    ',(null as any));
    this._el_91 = import3.createRenderElement(this.renderer,this._el_89,'div',new import3.InlineArray4(4,'class','eva-3-validation -lg -top-left','qadata','additionalAvailableRadioError'),(null as any));
    this._NgClass_91_3 = new import39.Wrapper_NgClass(this.parentView.parentView.parentView.injectorGet(import31.IterableDiffers,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import40.KeyValueDiffers,this.parentView.parentView.parentIndex),new import41.ElementRef(this._el_91),this.renderer);
    this._text_92 = this.renderer.createText(this._el_91,'\n\n                        ',(null as any));
    this._el_93 = import3.createRenderElement(this.renderer,this._el_91,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_94 = this.renderer.createText(this._el_93,'\n                            ',(null as any));
    this._el_95 = import3.createRenderElement(this.renderer,this._el_93,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_96 = this.renderer.createText(this._el_95,'\n                                ',(null as any));
    this._el_97 = import3.createRenderElement(this.renderer,this._el_95,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_98 = this.renderer.createText(this._el_97,'\n                                    ',(null as any));
    this._el_99 = import3.createRenderElement(this.renderer,this._el_97,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_100 = this.renderer.createText(this._el_99,'',(null as any));
    this._text_101 = this.renderer.createText(this._el_97,'\n                                ',(null as any));
    this._text_102 = this.renderer.createText(this._el_95,'\n                            ',(null as any));
    this._text_103 = this.renderer.createText(this._el_93,'\n\n                            ',(null as any));
    this._el_104 = import3.createRenderElement(this.renderer,this._el_93,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_105 = this.renderer.createText(this._el_104,'\n                                ',(null as any));
    this._el_106 = import3.createRenderElement(this.renderer,this._el_104,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_107 = this.renderer.createText(this._el_106,'\n                                    ',(null as any));
    this._el_108 = import3.createRenderElement(this.renderer,this._el_106,'dsp-message',new import3.InlineArray2(2,'closable','false'),(null as any));
    this._text_109 = this.renderer.createText(this._el_108,'\n                                        ',(null as any));
    this._el_110 = import3.createRenderElement(this.renderer,this._el_108,'p',new import3.InlineArray2(2,'class','eva-3-p message-text -eva-3-pt-sm'),(null as any));
    this._text_111 = this.renderer.createText(this._el_110,'',(null as any));
    this._text_112 = this.renderer.createText(this._el_108,'\n                                    ',(null as any));
    this._text_113 = this.renderer.createText(this._el_106,'\n                                ',(null as any));
    this._text_114 = this.renderer.createText(this._el_104,'\n                            ',(null as any));
    this._text_115 = this.renderer.createText(this._el_93,'\n\n                            ',(null as any));
    this._anchor_116 = this.renderer.createTemplateAnchor(this._el_93,(null as any));
    this._vc_116 = new import23.ViewContainer(116,93,this,this._anchor_116);
    this._TemplateRef_116_5 = new import30.TemplateRef_(this,116,this._anchor_116);
    this._NgIf_116_6 = new import33.Wrapper_NgIf(this._vc_116.vcRef,this._TemplateRef_116_5);
    this._text_117 = this.renderer.createText(this._el_93,'\n                        ',(null as any));
    this._text_118 = this.renderer.createText(this._el_91,'\n                        ',(null as any));
    this._el_119 = import3.createRenderElement(this.renderer,this._el_91,'span',new import3.InlineArray2(2,'class','validation-msg'),(null as any));
    this._text_120 = this.renderer.createText(this._el_119,'',(null as any));
    this._text_121 = this.renderer.createText(this._el_91,'\n\n                    ',(null as any));
    this._text_122 = this.renderer.createText(this._el_89,'\n\n                ',(null as any));
    this._text_123 = this.renderer.createText(this._el_2,'\n\n                ',(null as any));
    this._text_124 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_125 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_126 = this.renderer.createText(this._el_125,'\n                    ',(null as any));
    this._el_127 = import3.createRenderElement(this.renderer,this._el_125,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_128 = this.renderer.createText(this._el_127,'\n                        ',(null as any));
    this._el_129 = import3.createRenderElement(this.renderer,this._el_127,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_130 = this.renderer.createText(this._el_129,'\n                            ',(null as any));
    this._el_131 = import3.createRenderElement(this.renderer,this._el_129,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_132 = this.renderer.createText(this._el_131,'\n                                ',(null as any));
    this._el_133 = import3.createRenderElement(this.renderer,this._el_131,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_134 = this.renderer.createText(this._el_133,'',(null as any));
    this._text_135 = this.renderer.createText(this._el_131,'\n                            ',(null as any));
    this._text_136 = this.renderer.createText(this._el_129,'\n                        ',(null as any));
    this._text_137 = this.renderer.createText(this._el_127,'\n                        ',(null as any));
    this._el_138 = import3.createRenderElement(this.renderer,this._el_127,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_139 = this.renderer.createText(this._el_138,'\n                            ',(null as any));
    this._el_140 = import3.createRenderElement(this.renderer,this._el_138,'div',new import3.InlineArray2(2,'class','col -lg-3 -md-6 -sm-12'),(null as any));
    this._text_141 = this.renderer.createText(this._el_140,'\n                                ',(null as any));
    this._el_142 = import3.createRenderElement(this.renderer,this._el_140,'div',new import3.InlineArray2(2,'class','content eva-3-validation -top-left'),(null as any));
    this._text_143 = this.renderer.createText(this._el_142,'\n                                    ',(null as any));
    this._el_144 = import3.createRenderElement(this.renderer,this._el_142,'div',new import3.InlineArray2(2,'class','eva-3-input -md -icon-right'),(null as any));
    this._text_145 = this.renderer.createText(this._el_144,'\n                                        ',(null as any));
    this._el_146 = import3.createRenderElement(this.renderer,this._el_144,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_146 = new import36.View_InputContainerComponent0(this.viewUtils,this,146,this._el_146);
    this._InputContainerComponent_146_3 = new import36.Wrapper_InputContainerComponent();
    this._text_147 = this.renderer.createText((null as any),'\n                                        ',(null as any));
    this.compView_146.create(this._InputContainerComponent_146_3.context);
    this._text_148 = this.renderer.createText(this._el_144,'\n                                    ',(null as any));
    this._text_149 = this.renderer.createText(this._el_142,'\n                                ',(null as any));
    this._text_150 = this.renderer.createText(this._el_140,'\n                            ',(null as any));
    this._text_151 = this.renderer.createText(this._el_138,'\n                            ',(null as any));
    this._el_152 = import3.createRenderElement(this.renderer,this._el_138,'div',new import3.InlineArray2(2,'class','-md-1 -sm-2 -eva-3-mt-lg -eva-3-pl-xsm'),(null as any));
    this._text_153 = this.renderer.createText(this._el_152,'\n                                ',(null as any));
    this._el_154 = import3.createRenderElement(this.renderer,this._el_152,'span',new import3.InlineArray2(2,'class','percentage-label'),(null as any));
    this._text_155 = this.renderer.createText(this._el_154,'',(null as any));
    this._text_156 = this.renderer.createText(this._el_152,'\n                            ',(null as any));
    this._text_157 = this.renderer.createText(this._el_138,'\n                            ',(null as any));
    this._anchor_158 = this.renderer.createTemplateAnchor(this._el_138,(null as any));
    this._vc_158 = new import23.ViewContainer(158,138,this,this._anchor_158);
    this._TemplateRef_158_5 = new import30.TemplateRef_(this,158,this._anchor_158);
    this._NgIf_158_6 = new import33.Wrapper_NgIf(this._vc_158.vcRef,this._TemplateRef_158_5);
    this._text_159 = this.renderer.createText(this._el_138,'\n                        ',(null as any));
    this._text_160 = this.renderer.createText(this._el_127,'\n                    ',(null as any));
    this._text_161 = this.renderer.createText(this._el_125,'\n                ',(null as any));
    this._text_162 = this.renderer.createText(this._el_2,'\n\n\n                ',(null as any));
    this._el_163 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_164 = this.renderer.createText(this._el_163,'\n                    ',(null as any));
    this._el_165 = import3.createRenderElement(this.renderer,this._el_163,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_166 = this.renderer.createText(this._el_165,'\n\n                        ',(null as any));
    this._el_167 = import3.createRenderElement(this.renderer,this._el_165,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_168 = this.renderer.createText(this._el_167,'\n                            ',(null as any));
    this._el_169 = import3.createRenderElement(this.renderer,this._el_167,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_170 = this.renderer.createText(this._el_169,'\n                                ',(null as any));
    this._el_171 = import3.createRenderElement(this.renderer,this._el_169,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_172 = this.renderer.createText(this._el_171,'',(null as any));
    this._text_173 = this.renderer.createText(this._el_169,'\n                                ',(null as any));
    this._el_174 = import3.createRenderElement(this.renderer,this._el_169,'p',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_175 = this.renderer.createText(this._el_174,'',(null as any));
    this._text_176 = this.renderer.createText(this._el_169,'\n                            ',(null as any));
    this._text_177 = this.renderer.createText(this._el_167,'\n                        ',(null as any));
    this._text_178 = this.renderer.createText(this._el_165,'\n                        ',(null as any));
    this._el_179 = import3.createRenderElement(this.renderer,this._el_165,'div',new import3.InlineArray2(2,'class','eva-3-validation -lg -top-left'),(null as any));
    this._NgClass_179_3 = new import39.Wrapper_NgClass(this.parentView.parentView.parentView.injectorGet(import31.IterableDiffers,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import40.KeyValueDiffers,this.parentView.parentView.parentIndex),new import41.ElementRef(this._el_179),this.renderer);
    this._text_180 = this.renderer.createText(this._el_179,'\n\n                        ',(null as any));
    this._el_181 = import3.createRenderElement(this.renderer,this._el_179,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_182 = this.renderer.createText(this._el_181,'\n\n                            ',(null as any));
    this._el_183 = import3.createRenderElement(this.renderer,this._el_181,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_184 = this.renderer.createText(this._el_183,'\n                                ',(null as any));
    this._el_185 = import3.createRenderElement(this.renderer,this._el_183,'checkbox-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_185 = new import22.View_CheckboxContainerComponent0(this.viewUtils,this,185,this._el_185);
    this._CheckboxContainerComponent_185_3 = new import22.Wrapper_CheckboxContainerComponent();
    this._text_186 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this.compView_185.create(this._CheckboxContainerComponent_185_3.context);
    this._text_187 = this.renderer.createText(this._el_183,'\n                                ',(null as any));
    this._el_188 = import3.createRenderElement(this.renderer,this._el_183,'label',new import3.InlineArray2(2,'class','-eva-3-pb-sm eva-3-h5'),(null as any));
    this._text_189 = this.renderer.createText(this._el_188,'',(null as any));
    this._text_190 = this.renderer.createText(this._el_183,'\n                            ',(null as any));
    this._text_191 = this.renderer.createText(this._el_181,'\n                        ',(null as any));
    this._text_192 = this.renderer.createText(this._el_179,'\n                        ',(null as any));
    this._el_193 = import3.createRenderElement(this.renderer,this._el_179,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_194 = this.renderer.createText(this._el_193,'\n                            ',(null as any));
    this._el_195 = import3.createRenderElement(this.renderer,this._el_193,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_196 = this.renderer.createText(this._el_195,'\n                                ',(null as any));
    this._el_197 = import3.createRenderElement(this.renderer,this._el_195,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_198 = this.renderer.createText(this._el_197,'\n                                    ',(null as any));
    this._el_199 = import3.createRenderElement(this.renderer,this._el_197,'p',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_200 = this.renderer.createText(this._el_199,'',(null as any));
    this._text_201 = this.renderer.createText(this._el_197,'\n                                ',(null as any));
    this._text_202 = this.renderer.createText(this._el_195,'\n                            ',(null as any));
    this._text_203 = this.renderer.createText(this._el_193,'\n\n                            ',(null as any));
    this._el_204 = import3.createRenderElement(this.renderer,this._el_193,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-md'),(null as any));
    this._text_205 = this.renderer.createText(this._el_204,'\n                                ',(null as any));
    this._el_206 = import3.createRenderElement(this.renderer,this._el_204,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_207 = this.renderer.createText(this._el_206,'\n                                    ',(null as any));
    this._el_208 = import3.createRenderElement(this.renderer,this._el_206,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md -eva-3-pb-sm'),(null as any));
    this._text_209 = this.renderer.createText(this._el_208,'',(null as any));
    this._text_210 = this.renderer.createText(this._el_206,'\n                                ',(null as any));
    this._text_211 = this.renderer.createText(this._el_204,'\n                                ',(null as any));
    this._el_212 = import3.createRenderElement(this.renderer,this._el_204,'div',new import3.InlineArray2(2,'class','col -lg-3 -md-6 -sm-12'),(null as any));
    this._text_213 = this.renderer.createText(this._el_212,'\n                                    ',(null as any));
    this._el_214 = import3.createRenderElement(this.renderer,this._el_212,'div',new import3.InlineArray2(2,'class','content eva-3-validation -top-left'),(null as any));
    this._text_215 = this.renderer.createText(this._el_214,'\n                                        ',(null as any));
    this._el_216 = import3.createRenderElement(this.renderer,this._el_214,'div',new import3.InlineArray2(2,'class','eva-3-input -md -icon-right'),(null as any));
    this._text_217 = this.renderer.createText(this._el_216,'\n                                            ',(null as any));
    this._el_218 = import3.createRenderElement(this.renderer,this._el_216,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_218 = new import36.View_InputContainerComponent0(this.viewUtils,this,218,this._el_218);
    this._InputContainerComponent_218_3 = new import36.Wrapper_InputContainerComponent();
    this.compView_218.create(this._InputContainerComponent_218_3.context);
    this._text_219 = this.renderer.createText(this._el_216,'\n                                        ',(null as any));
    this._text_220 = this.renderer.createText(this._el_214,'\n                                    ',(null as any));
    this._text_221 = this.renderer.createText(this._el_212,'\n                                ',(null as any));
    this._text_222 = this.renderer.createText(this._el_204,'\n                                ',(null as any));
    this._el_223 = import3.createRenderElement(this.renderer,this._el_204,'div',new import3.InlineArray2(2,'class','col -lg-1 -md-1 -sm-2 -eva-3-pl-xsm -eva-3-mt-lg'),(null as any));
    this._text_224 = this.renderer.createText(this._el_223,'\n                                    ',(null as any));
    this._el_225 = import3.createRenderElement(this.renderer,this._el_223,'span',new import3.InlineArray2(2,'class','percentage-label'),(null as any));
    this._text_226 = this.renderer.createText(this._el_225,'',(null as any));
    this._text_227 = this.renderer.createText(this._el_223,'\n                                ',(null as any));
    this._text_228 = this.renderer.createText(this._el_204,'\n                                ',(null as any));
    this._el_229 = import3.createRenderElement(this.renderer,this._el_204,'div',new import3.InlineArray2(2,'class','col -lg-6 -md-12 -sm-12 -eva-3-mt-lg'),(null as any));
    this._text_230 = this.renderer.createText(this._el_229,'\n                                    ',(null as any));
    this._el_231 = import3.createRenderElement(this.renderer,this._el_229,'span',new import3.InlineArray2(2,'class','eva-3-p information-box alert-info'),(null as any));
    this._el_232 = import3.createRenderElement(this.renderer,this._el_231,'i',new import3.InlineArray2(2,'class','fa fa-info'),(null as any));
    this._text_233 = this.renderer.createText(this._el_231,'',(null as any));
    this._text_234 = this.renderer.createText(this._el_229,'\n                                ',(null as any));
    this._text_235 = this.renderer.createText(this._el_204,'\n                            ',(null as any));
    this._text_236 = this.renderer.createText(this._el_193,'\n\n                            ',(null as any));
    this._el_237 = import3.createRenderElement(this.renderer,this._el_193,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_238 = this.renderer.createText(this._el_237,'\n                                ',(null as any));
    this._el_239 = import3.createRenderElement(this.renderer,this._el_237,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_240 = this.renderer.createText(this._el_239,'\n                                    ',(null as any));
    this._el_241 = import3.createRenderElement(this.renderer,this._el_239,'p',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_242 = this.renderer.createText(this._el_241,'',(null as any));
    this._text_243 = this.renderer.createText(this._el_239,'\n                                ',(null as any));
    this._text_244 = this.renderer.createText(this._el_237,'\n                            ',(null as any));
    this._text_245 = this.renderer.createText(this._el_193,'\n\n                            ',(null as any));
    this._el_246 = import3.createRenderElement(this.renderer,this._el_193,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_247 = this.renderer.createText(this._el_246,'\n                                ',(null as any));
    this._el_248 = import3.createRenderElement(this.renderer,this._el_246,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_249 = this.renderer.createText(this._el_248,'\n                                    ',(null as any));
    this._el_250 = import3.createRenderElement(this.renderer,this._el_248,'radio-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_250 = new import26.View_RadioContainerComponent0(this.viewUtils,this,250,this._el_250);
    this._RadioContainerComponent_250_3 = new import26.Wrapper_RadioContainerComponent();
    this._text_251 = this.renderer.createText((null as any),'\n                                    ',(null as any));
    this.compView_250.create(this._RadioContainerComponent_250_3.context);
    this._text_252 = this.renderer.createText(this._el_248,'\n                                ',(null as any));
    this._text_253 = this.renderer.createText(this._el_246,'\n                            ',(null as any));
    this._text_254 = this.renderer.createText(this._el_193,'\n\n                            ',(null as any));
    this._el_255 = import3.createRenderElement(this.renderer,this._el_193,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-xsm -eva-3-pb-sm'),(null as any));
    this._text_256 = this.renderer.createText(this._el_255,'\n                                ',(null as any));
    this._el_257 = import3.createRenderElement(this.renderer,this._el_255,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_258 = this.renderer.createText(this._el_257,'\n                                    ',(null as any));
    this._el_259 = import3.createRenderElement(this.renderer,this._el_257,'radio-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_259 = new import26.View_RadioContainerComponent0(this.viewUtils,this,259,this._el_259);
    this._RadioContainerComponent_259_3 = new import26.Wrapper_RadioContainerComponent();
    this._text_260 = this.renderer.createText((null as any),'\n                                    ',(null as any));
    this.compView_259.create(this._RadioContainerComponent_259_3.context);
    this._text_261 = this.renderer.createText(this._el_257,'\n                                ',(null as any));
    this._text_262 = this.renderer.createText(this._el_255,'\n                            ',(null as any));
    this._text_263 = this.renderer.createText(this._el_193,'\n                        ',(null as any));
    this._text_264 = this.renderer.createText(this._el_179,'\n\n\n                            ',(null as any));
    this._el_265 = import3.createRenderElement(this.renderer,this._el_179,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-xlg'),(null as any));
    this._text_266 = this.renderer.createText(this._el_265,'\n                                ',(null as any));
    this._el_267 = import3.createRenderElement(this.renderer,this._el_265,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_268 = this.renderer.createText(this._el_267,'\n                                    ',(null as any));
    this._el_269 = import3.createRenderElement(this.renderer,this._el_267,'checkbox-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_269 = new import22.View_CheckboxContainerComponent0(this.viewUtils,this,269,this._el_269);
    this._CheckboxContainerComponent_269_3 = new import22.Wrapper_CheckboxContainerComponent();
    this._text_270 = this.renderer.createText((null as any),'\n                                    ',(null as any));
    this.compView_269.create(this._CheckboxContainerComponent_269_3.context);
    this._text_271 = this.renderer.createText(this._el_267,'\n                                    ',(null as any));
    this._el_272 = import3.createRenderElement(this.renderer,this._el_267,'label',new import3.InlineArray2(2,'class','-eva-3-pb-sm eva-3-h5'),(null as any));
    this._text_273 = this.renderer.createText(this._el_272,'',(null as any));
    this._text_274 = this.renderer.createText(this._el_267,'\n                                ',(null as any));
    this._text_275 = this.renderer.createText(this._el_265,'\n                            ',(null as any));
    this._text_276 = this.renderer.createText(this._el_179,'\n                            ',(null as any));
    this._el_277 = import3.createRenderElement(this.renderer,this._el_179,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_278 = this.renderer.createText(this._el_277,'\n                                ',(null as any));
    this._el_279 = import3.createRenderElement(this.renderer,this._el_277,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_280 = this.renderer.createText(this._el_279,'\n                                    ',(null as any));
    this._el_281 = import3.createRenderElement(this.renderer,this._el_279,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_282 = this.renderer.createText(this._el_281,'\n                                        ',(null as any));
    this._el_283 = import3.createRenderElement(this.renderer,this._el_281,'p',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_284 = this.renderer.createText(this._el_283,'',(null as any));
    this._text_285 = this.renderer.createText(this._el_281,'\n                                    ',(null as any));
    this._text_286 = this.renderer.createText(this._el_279,'\n                                ',(null as any));
    this._text_287 = this.renderer.createText(this._el_277,'\n\n                                ',(null as any));
    this._anchor_288 = this.renderer.createTemplateAnchor(this._el_277,(null as any));
    this._vc_288 = new import23.ViewContainer(288,277,this,this._anchor_288);
    this._TemplateRef_288_5 = new import30.TemplateRef_(this,288,this._anchor_288);
    this._NgFor_288_6 = new import29.Wrapper_NgFor(this._vc_288.vcRef,this._TemplateRef_288_5,this.parentView.parentView.parentView.injectorGet(import31.IterableDiffers,this.parentView.parentView.parentIndex),this.parentView.parentView.ref);
    this._text_289 = this.renderer.createText(this._el_277,'\n                            ',(null as any));
    this._text_290 = this.renderer.createText(this._el_179,'\n                            ',(null as any));
    this._el_291 = import3.createRenderElement(this.renderer,this._el_179,'span',new import3.InlineArray2(2,'class','validation-msg'),(null as any));
    this._text_292 = this.renderer.createText(this._el_291,'',(null as any));
    this._text_293 = this.renderer.createText(this._el_179,'\n                        ',(null as any));
    this._text_294 = this.renderer.createText(this._el_165,'\n                    ',(null as any));
    this._text_295 = this.renderer.createText(this._el_163,'\n                ',(null as any));
    this._text_296 = this.renderer.createText(this._el_2,'\n\n                ',(null as any));
    this._el_297 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_298 = this.renderer.createText(this._el_297,'\n                    ',(null as any));
    this._el_299 = import3.createRenderElement(this.renderer,this._el_297,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_300 = this.renderer.createText(this._el_299,'\n                        ',(null as any));
    this._el_301 = import3.createRenderElement(this.renderer,this._el_299,'div',new import3.InlineArray2(2,'class','col -md-12 -md-6'),(null as any));
    this._text_302 = this.renderer.createText(this._el_301,'\n                            ',(null as any));
    this._el_303 = import3.createRenderElement(this.renderer,this._el_301,'dsp-button',new import3.InlineArray8(6,'qadata','save','size','md','variation','primary'),(null as any));
    this._text_304 = this.renderer.createText(this._el_303,'',(null as any));
    this._text_305 = this.renderer.createText(this._el_301,'\n                            ',(null as any));
    this._el_306 = import3.createRenderElement(this.renderer,this._el_301,'dsp-button',new import3.InlineArray4(4,'size','md','variation','link'),(null as any));
    this._text_307 = this.renderer.createText(this._el_306,'',(null as any));
    this._text_308 = this.renderer.createText(this._el_301,'\n                        ',(null as any));
    this._text_309 = this.renderer.createText(this._el_299,'\n                    ',(null as any));
    this._text_310 = this.renderer.createText(this._el_297,'\n                ',(null as any));
    this._text_311 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_312 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray4(4,'submit',(null as any),'reset',(null as any)),this.eventHandler(this.handleEvent_0));
    this._pipe_translate_0 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_31,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_31));
    this._pipe_translate_2 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_34,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_34));
    this._pipe_translate_3 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_4 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_5 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_6 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_7 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_8 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_9 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_10 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_11 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_146,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_146));
    this._InputContainerComponent_146_3.subscribe(this,this.eventHandler(this.handleEvent_146),false,false,true);
    this._pipe_translate_12 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_13 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_14 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    var disposable_4:Function = import3.subscribeToRenderElement(this,this._el_185,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_185));
    this._CheckboxContainerComponent_185_3.subscribe(this,this.eventHandler(this.handleEvent_185),false,true);
    this._pipe_translate_15 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_16 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_17 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    var disposable_5:Function = import3.subscribeToRenderElement(this,this._el_218,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_218));
    this._InputContainerComponent_218_3.subscribe(this,this.eventHandler(this.handleEvent_218),false,false,true);
    this._pipe_translate_18 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_19 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_20 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    var disposable_6:Function = import3.subscribeToRenderElement(this,this._el_250,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_250));
    this._RadioContainerComponent_250_3.subscribe(this,this.eventHandler(this.handleEvent_250),false,true);
    this._pipe_translate_21 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    var disposable_7:Function = import3.subscribeToRenderElement(this,this._el_259,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_259));
    this._RadioContainerComponent_259_3.subscribe(this,this.eventHandler(this.handleEvent_259),false,true);
    this._pipe_translate_22 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    var disposable_8:Function = import3.subscribeToRenderElement(this,this._el_269,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_269));
    this._CheckboxContainerComponent_269_3.subscribe(this,this.eventHandler(this.handleEvent_269),false,true);
    this._pipe_translate_23 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_24 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_25 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    var disposable_9:Function = import3.subscribeToRenderElement(this,this._el_303,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_303));
    this._pipe_translate_26 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    var disposable_10:Function = import3.subscribeToRenderElement(this,this._el_306,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_306));
    this._pipe_translate_27 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._el_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._text_36,
      this._text_37,
      this._text_38,
      this._text_39,
      this._text_40,
      this._el_41,
      this._text_42,
      this._anchor_43,
      this._text_44,
      this._text_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._text_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._el_53,
      this._text_54,
      this._el_55,
      this._text_56,
      this._el_57,
      this._text_58,
      this._el_59,
      this._text_60,
      this._el_61,
      this._text_62,
      this._el_63,
      this._text_64,
      this._text_65,
      this._text_66,
      this._text_67,
      this._el_68,
      this._text_69,
      this._el_70,
      this._text_71,
      this._el_72,
      this._text_73,
      this._el_74,
      this._text_75,
      this._text_76,
      this._text_77,
      this._text_78,
      this._text_79,
      this._anchor_80,
      this._text_81,
      this._text_82,
      this._el_83,
      this._text_84,
      this._text_85,
      this._text_86,
      this._text_87,
      this._text_88,
      this._el_89,
      this._text_90,
      this._el_91,
      this._text_92,
      this._el_93,
      this._text_94,
      this._el_95,
      this._text_96,
      this._el_97,
      this._text_98,
      this._el_99,
      this._text_100,
      this._text_101,
      this._text_102,
      this._text_103,
      this._el_104,
      this._text_105,
      this._el_106,
      this._text_107,
      this._el_108,
      this._text_109,
      this._el_110,
      this._text_111,
      this._text_112,
      this._text_113,
      this._text_114,
      this._text_115,
      this._anchor_116,
      this._text_117,
      this._text_118,
      this._el_119,
      this._text_120,
      this._text_121,
      this._text_122,
      this._text_123,
      this._text_124,
      this._el_125,
      this._text_126,
      this._el_127,
      this._text_128,
      this._el_129,
      this._text_130,
      this._el_131,
      this._text_132,
      this._el_133,
      this._text_134,
      this._text_135,
      this._text_136,
      this._text_137,
      this._el_138,
      this._text_139,
      this._el_140,
      this._text_141,
      this._el_142,
      this._text_143,
      this._el_144,
      this._text_145,
      this._el_146,
      this._text_147,
      this._text_148,
      this._text_149,
      this._text_150,
      this._text_151,
      this._el_152,
      this._text_153,
      this._el_154,
      this._text_155,
      this._text_156,
      this._text_157,
      this._anchor_158,
      this._text_159,
      this._text_160,
      this._text_161,
      this._text_162,
      this._el_163,
      this._text_164,
      this._el_165,
      this._text_166,
      this._el_167,
      this._text_168,
      this._el_169,
      this._text_170,
      this._el_171,
      this._text_172,
      this._text_173,
      this._el_174,
      this._text_175,
      this._text_176,
      this._text_177,
      this._text_178,
      this._el_179,
      this._text_180,
      this._el_181,
      this._text_182,
      this._el_183,
      this._text_184,
      this._el_185,
      this._text_186,
      this._text_187,
      this._el_188,
      this._text_189,
      this._text_190,
      this._text_191,
      this._text_192,
      this._el_193,
      this._text_194,
      this._el_195,
      this._text_196,
      this._el_197,
      this._text_198,
      this._el_199,
      this._text_200,
      this._text_201,
      this._text_202,
      this._text_203,
      this._el_204,
      this._text_205,
      this._el_206,
      this._text_207,
      this._el_208,
      this._text_209,
      this._text_210,
      this._text_211,
      this._el_212,
      this._text_213,
      this._el_214,
      this._text_215,
      this._el_216,
      this._text_217,
      this._el_218,
      this._text_219,
      this._text_220,
      this._text_221,
      this._text_222,
      this._el_223,
      this._text_224,
      this._el_225,
      this._text_226,
      this._text_227,
      this._text_228,
      this._el_229,
      this._text_230,
      this._el_231,
      this._el_232,
      this._text_233,
      this._text_234,
      this._text_235,
      this._text_236,
      this._el_237,
      this._text_238,
      this._el_239,
      this._text_240,
      this._el_241,
      this._text_242,
      this._text_243,
      this._text_244,
      this._text_245,
      this._el_246,
      this._text_247,
      this._el_248,
      this._text_249,
      this._el_250,
      this._text_251,
      this._text_252,
      this._text_253,
      this._text_254,
      this._el_255,
      this._text_256,
      this._el_257,
      this._text_258,
      this._el_259,
      this._text_260,
      this._text_261,
      this._text_262,
      this._text_263,
      this._text_264,
      this._el_265,
      this._text_266,
      this._el_267,
      this._text_268,
      this._el_269,
      this._text_270,
      this._text_271,
      this._el_272,
      this._text_273,
      this._text_274,
      this._text_275,
      this._text_276,
      this._el_277,
      this._text_278,
      this._el_279,
      this._text_280,
      this._el_281,
      this._text_282,
      this._el_283,
      this._text_284,
      this._text_285,
      this._text_286,
      this._text_287,
      this._anchor_288,
      this._text_289,
      this._text_290,
      this._el_291,
      this._text_292,
      this._text_293,
      this._text_294,
      this._text_295,
      this._text_296,
      this._el_297,
      this._text_298,
      this._el_299,
      this._text_300,
      this._el_301,
      this._text_302,
      this._el_303,
      this._text_304,
      this._text_305,
      this._el_306,
      this._text_307,
      this._text_308,
      this._text_309,
      this._text_310,
      this._text_311,
      this._text_312
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6,
      disposable_7,
      disposable_8,
      disposable_9,
      disposable_10
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import30.TemplateRef) && (43 === requestNodeIndex))) { return this._TemplateRef_43_5; }
    if (((token === import32.NgFor) && (43 === requestNodeIndex))) { return this._NgFor_43_6.context; }
    if (((token === import42.NgClass) && ((16 <= requestNodeIndex) && (requestNodeIndex <= 49)))) { return this._NgClass_16_3.context; }
    if (((token === import30.TemplateRef) && (80 === requestNodeIndex))) { return this._TemplateRef_80_5; }
    if (((token === import34.NgIf) && (80 === requestNodeIndex))) { return this._NgIf_80_6.context; }
    if (((token === import42.NgClass) && ((55 <= requestNodeIndex) && (requestNodeIndex <= 85)))) { return this._NgClass_55_3.context; }
    if (((token === import30.TemplateRef) && (116 === requestNodeIndex))) { return this._TemplateRef_116_5; }
    if (((token === import34.NgIf) && (116 === requestNodeIndex))) { return this._NgIf_116_6.context; }
    if (((token === import42.NgClass) && ((91 <= requestNodeIndex) && (requestNodeIndex <= 121)))) { return this._NgClass_91_3.context; }
    if (((token === import35.InputContainerComponent) && ((146 <= requestNodeIndex) && (requestNodeIndex <= 147)))) { return this._InputContainerComponent_146_3.context; }
    if (((token === import30.TemplateRef) && (158 === requestNodeIndex))) { return this._TemplateRef_158_5; }
    if (((token === import34.NgIf) && (158 === requestNodeIndex))) { return this._NgIf_158_6.context; }
    if (((token === import21.CheckboxContainerComponent) && ((185 <= requestNodeIndex) && (requestNodeIndex <= 186)))) { return this._CheckboxContainerComponent_185_3.context; }
    if (((token === import35.InputContainerComponent) && (218 === requestNodeIndex))) { return this._InputContainerComponent_218_3.context; }
    if (((token === import25.RadioContainerComponent) && ((250 <= requestNodeIndex) && (requestNodeIndex <= 251)))) { return this._RadioContainerComponent_250_3.context; }
    if (((token === import25.RadioContainerComponent) && ((259 <= requestNodeIndex) && (requestNodeIndex <= 260)))) { return this._RadioContainerComponent_259_3.context; }
    if (((token === import21.CheckboxContainerComponent) && ((269 <= requestNodeIndex) && (requestNodeIndex <= 270)))) { return this._CheckboxContainerComponent_269_3.context; }
    if (((token === import30.TemplateRef) && (288 === requestNodeIndex))) { return this._TemplateRef_288_5; }
    if (((token === import32.NgFor) && (288 === requestNodeIndex))) { return this._NgFor_288_6.context; }
    if (((token === import42.NgClass) && ((179 <= requestNodeIndex) && (requestNodeIndex <= 293)))) { return this._NgClass_179_3.context; }
    if (((token === import43.NgForm) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 312)))) { return this._NgForm_0_3.context; }
    if (((token === import44.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 312)))) { return this._ControlContainer_0_4; }
    if (((token === import45.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 312)))) { return this._NgControlStatusGroup_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import24.ValueUnwrapper();
    this._NgForm_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_16_0_0:any = 'eva-3-validation -lg -top-left';
    this._NgClass_16_3.check_klass(currVal_16_0_0,throwOnChange,false);
    const currVal_16_0_1:any = this._map_349(!!this.parentView.parentView.context.errors['posSelected']);
    this._NgClass_16_3.check_ngClass(currVal_16_0_1,throwOnChange,false);
    this._NgClass_16_3.ngDoCheck(this,this._el_16,throwOnChange);
    const currVal_43_0_0:any = this.parentView.parentView.context.pointsOfSale;
    this._NgFor_43_6.check_ngForOf(currVal_43_0_0,throwOnChange,false);
    this._NgFor_43_6.ngDoCheck(this,this._anchor_43,throwOnChange);
    const currVal_55_0_0:any = 'eva-3-validation -lg -top-left';
    this._NgClass_55_3.check_klass(currVal_55_0_0,throwOnChange,false);
    const currVal_55_0_1:any = this._map_359(!!this.parentView.parentView.context.errors['additionalSelection']);
    this._NgClass_55_3.check_ngClass(currVal_55_0_1,throwOnChange,false);
    this._NgClass_55_3.ngDoCheck(this,this._el_55,throwOnChange);
    const currVal_80_0_0:boolean = !!this.parentView.parentView.context.notEnsuredAdditionals;
    this._NgIf_80_6.check_ngIf(currVal_80_0_0,throwOnChange,false);
    this._NgIf_80_6.ngDoCheck(this,this._anchor_80,throwOnChange);
    const currVal_91_0_0:any = 'eva-3-validation -lg -top-left';
    this._NgClass_91_3.check_klass(currVal_91_0_0,throwOnChange,false);
    const currVal_91_0_1:any = this._map_366(!!this.parentView.parentView.context.errors['additionalSelection']);
    this._NgClass_91_3.check_ngClass(currVal_91_0_1,throwOnChange,false);
    this._NgClass_91_3.ngDoCheck(this,this._el_91,throwOnChange);
    const currVal_116_0_0:boolean = !!this.parentView.parentView.context.ensuredAdditionals;
    this._NgIf_116_6.check_ngIf(currVal_116_0_0,throwOnChange,false);
    this._NgIf_116_6.ngDoCheck(this,this._anchor_116,throwOnChange);
    const currVal_146_0_0:any = 0;
    this._InputContainerComponent_146_3.check_placeholder(currVal_146_0_0,throwOnChange,false);
    const currVal_146_0_1:any = 'addprice';
    this._InputContainerComponent_146_3.check_name(currVal_146_0_1,throwOnChange,false);
    const currVal_146_0_2:boolean = !!this.parentView.parentView.context.errors['baseAmount'];
    this._InputContainerComponent_146_3.check_invalid(currVal_146_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_146_0_3:any = valUnwrapper.unwrap(this._pipe_translate_12.transform(this.parentView.parentView.context.errorMessages['baseAmount']));
    this._InputContainerComponent_146_3.check_invalidText(currVal_146_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_146_0_4:any = ((this.parentView.parentView.context.included == true) && (!!this.parentView.parentView.context.additionalSelected.addSelected && ((this.parentView.parentView.context.additionalSelected.addSelected == 'ADD') || (this.parentView.parentView.context.additionalSelected.addSelected == 'PTG'))));
    this._InputContainerComponent_146_3.check_disabled(currVal_146_0_4,throwOnChange,false);
    const currVal_146_0_5:any = this.parentView.parentView.context.additionalSelected.baseAmount;
    this._InputContainerComponent_146_3.check_model(currVal_146_0_5,throwOnChange,false);
    this._InputContainerComponent_146_3.ngDoCheck(this,this._el_146,throwOnChange);
    const currVal_158_0_0:boolean = (!!this.parentView.parentView.context.additionalSelected.addSelected && ((this.parentView.parentView.context.additionalSelected.addSelected == 'ADD') || (this.parentView.parentView.context.additionalSelected.addSelected == 'PTG')));
    this._NgIf_158_6.check_ngIf(currVal_158_0_0,throwOnChange,false);
    this._NgIf_158_6.ngDoCheck(this,this._anchor_158,throwOnChange);
    const currVal_179_0_0:any = 'eva-3-validation -lg -top-left';
    this._NgClass_179_3.check_klass(currVal_179_0_0,throwOnChange,false);
    const currVal_179_0_1:any = this._map_383(!!this.parentView.parentView.context.errors['tollSelection']);
    this._NgClass_179_3.check_ngClass(currVal_179_0_1,throwOnChange,false);
    this._NgClass_179_3.ngDoCheck(this,this._el_179,throwOnChange);
    const currVal_185_0_0:any = 'unlimitedToll';
    this._CheckboxContainerComponent_185_3.check_name(currVal_185_0_0,throwOnChange,false);
    const currVal_185_0_1:any = 'sm';
    this._CheckboxContainerComponent_185_3.check_size(currVal_185_0_1,throwOnChange,false);
    const currVal_185_0_2:any = this.parentView.parentView.context.isEditing;
    this._CheckboxContainerComponent_185_3.check_disabled(currVal_185_0_2,throwOnChange,false);
    const currVal_185_0_3:any = this.parentView.parentView.context.showUnlimited;
    this._CheckboxContainerComponent_185_3.check_model(currVal_185_0_3,throwOnChange,false);
    this._CheckboxContainerComponent_185_3.ngDoCheck(this,this._el_185,throwOnChange);
    const currVal_218_0_0:any = 0;
    this._InputContainerComponent_218_3.check_placeholder(currVal_218_0_0,throwOnChange,false);
    const currVal_218_0_1:any = 'unlimitedTollBaseAmount';
    this._InputContainerComponent_218_3.check_name(currVal_218_0_1,throwOnChange,false);
    const currVal_218_0_2:boolean = !!this.parentView.parentView.context.errors['unlimitedTollBaseAmount'];
    this._InputContainerComponent_218_3.check_invalid(currVal_218_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_218_0_3:any = valUnwrapper.unwrap(this._pipe_translate_18.transform(this.parentView.parentView.context.errorMessages['unlimitedTollBaseAmount']));
    this._InputContainerComponent_218_3.check_invalidText(currVal_218_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_218_0_4:any = this.parentView.parentView.context.unlimitedToll.baseAmount;
    this._InputContainerComponent_218_3.check_model(currVal_218_0_4,throwOnChange,false);
    this._InputContainerComponent_218_3.ngDoCheck(this,this._el_218,throwOnChange);
    const currVal_250_0_0:any = 'true';
    this._RadioContainerComponent_250_3.check_id(currVal_250_0_0,throwOnChange,false);
    const currVal_250_0_1:any = true;
    this._RadioContainerComponent_250_3.check_value(currVal_250_0_1,throwOnChange,false);
    const currVal_250_0_2:any = 'tollExpressLane';
    this._RadioContainerComponent_250_3.check_name(currVal_250_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_250_0_3:any = valUnwrapper.unwrap(this._pipe_translate_21.transform('additionalPrice.toll.YES_LANE'));
    this._RadioContainerComponent_250_3.check_label(currVal_250_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_250_0_4:any = this.parentView.parentView.context.unlimitedToll.lane;
    this._RadioContainerComponent_250_3.check_model(currVal_250_0_4,throwOnChange,false);
    this._RadioContainerComponent_250_3.ngDoCheck(this,this._el_250,throwOnChange);
    const currVal_259_0_0:any = 'false';
    this._RadioContainerComponent_259_3.check_id(currVal_259_0_0,throwOnChange,false);
    const currVal_259_0_1:any = false;
    this._RadioContainerComponent_259_3.check_value(currVal_259_0_1,throwOnChange,false);
    const currVal_259_0_2:any = 'tollExpressLane';
    this._RadioContainerComponent_259_3.check_name(currVal_259_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_259_0_3:any = valUnwrapper.unwrap(this._pipe_translate_22.transform('additionalPrice.toll.NO_LANE'));
    this._RadioContainerComponent_259_3.check_label(currVal_259_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_259_0_4:any = this.parentView.parentView.context.unlimitedToll.lane;
    this._RadioContainerComponent_259_3.check_model(currVal_259_0_4,throwOnChange,false);
    this._RadioContainerComponent_259_3.ngDoCheck(this,this._el_259,throwOnChange);
    const currVal_269_0_0:any = 'limitedToll';
    this._CheckboxContainerComponent_269_3.check_name(currVal_269_0_0,throwOnChange,false);
    const currVal_269_0_1:any = 'sm';
    this._CheckboxContainerComponent_269_3.check_size(currVal_269_0_1,throwOnChange,false);
    const currVal_269_0_2:any = this.parentView.parentView.context.isEditing;
    this._CheckboxContainerComponent_269_3.check_disabled(currVal_269_0_2,throwOnChange,false);
    const currVal_269_0_3:any = this.parentView.parentView.context.showLimited;
    this._CheckboxContainerComponent_269_3.check_model(currVal_269_0_3,throwOnChange,false);
    this._CheckboxContainerComponent_269_3.ngDoCheck(this,this._el_269,throwOnChange);
    const currVal_288_0_0:any = this.parentView.parentView.context.tollConsList;
    this._NgFor_288_6.check_ngForOf(currVal_288_0_0,throwOnChange,false);
    this._NgFor_288_6.ngDoCheck(this,this._anchor_288,throwOnChange);
    this._vc_43.detectChangesInNestedViews(throwOnChange);
    this._vc_80.detectChangesInNestedViews(throwOnChange);
    this._vc_116.detectChangesInNestedViews(throwOnChange);
    this._vc_158.detectChangesInNestedViews(throwOnChange);
    this._vc_288.detectChangesInNestedViews(throwOnChange);
    this._NgControlStatusGroup_0_5.checkHost(this,this,this._el_0,throwOnChange);
    valUnwrapper.reset();
    const currVal_347:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('additionalPrice.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_347,currVal_347))) {
      this.renderer.setText(this._text_9,currVal_347);
      this._expr_347 = currVal_347;
    }
    valUnwrapper.reset();
    const currVal_350:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('additionalPrice.POS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_350,currVal_350))) {
      this.renderer.setText(this._text_25,currVal_350);
      this._expr_350 = currVal_350;
    }
    const currVal_352:any = this.parentView.parentView.context.isEditing;
    if (import3.checkBinding(throwOnChange,this._expr_352,currVal_352)) {
      this.renderer.setElementProperty(this._el_27,'hidden',currVal_352);
      this._expr_352 = currVal_352;
    }
    valUnwrapper.reset();
    const currVal_353:any = import3.inlineInterpolate(1,'\n                                                ',valUnwrapper.unwrap(this._pipe_translate_2.transform('common.ALL')),'\n                                            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_353,currVal_353))) {
      this.renderer.setText(this._text_32,currVal_353);
      this._expr_353 = currVal_353;
    }
    valUnwrapper.reset();
    const currVal_355:any = import3.inlineInterpolate(1,'\n                                                ',valUnwrapper.unwrap(this._pipe_translate_3.transform('common.NONE')),'\n                                            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_355,currVal_355))) {
      this.renderer.setText(this._text_35,currVal_355);
      this._expr_355 = currVal_355;
    }
    valUnwrapper.reset();
    const currVal_357:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform(this.parentView.parentView.context.errorMessages['posSelected'])),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_357,currVal_357))) {
      this.renderer.setText(this._text_48,currVal_357);
      this._expr_357 = currVal_357;
    }
    valUnwrapper.reset();
    const currVal_360:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('additionalPrice.ADD_NOT_AVAILABLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_360,currVal_360))) {
      this.renderer.setText(this._text_64,currVal_360);
      this._expr_360 = currVal_360;
    }
    valUnwrapper.reset();
    const currVal_362:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('additionalPrice.ADD_NOT_AVAILABLE_DESCRIPTION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_362,currVal_362))) {
      this.renderer.setText(this._text_75,currVal_362);
      this._expr_362 = currVal_362;
    }
    valUnwrapper.reset();
    const currVal_364:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform(this.parentView.parentView.context.errorMessages['additionalSelection'])),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_364,currVal_364))) {
      this.renderer.setText(this._text_84,currVal_364);
      this._expr_364 = currVal_364;
    }
    valUnwrapper.reset();
    const currVal_367:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_8.transform('additionalPrice.ADD_AVAILABLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_367,currVal_367))) {
      this.renderer.setText(this._text_100,currVal_367);
      this._expr_367 = currVal_367;
    }
    valUnwrapper.reset();
    const currVal_369:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_9.transform('additionalPrice.ADD_AVAILABLE_DESCRIPTION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_369,currVal_369))) {
      this.renderer.setText(this._text_111,currVal_369);
      this._expr_369 = currVal_369;
    }
    valUnwrapper.reset();
    const currVal_371:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_10.transform(this.parentView.parentView.context.errorMessages['additionalSelection'])),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_371,currVal_371))) {
      this.renderer.setText(this._text_120,currVal_371);
      this._expr_371 = currVal_371;
    }
    const currVal_373:any = (this.parentView.parentView.context.additionalSelected.addSelected == 'TOLL');
    if (import3.checkBinding(throwOnChange,this._expr_373,currVal_373)) {
      this.renderer.setElementProperty(this._el_125,'hidden',currVal_373);
      this._expr_373 = currVal_373;
    }
    valUnwrapper.reset();
    const currVal_374:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_11.transform('additionalPrice.PRICE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_374,currVal_374))) {
      this.renderer.setText(this._text_134,currVal_374);
      this._expr_374 = currVal_374;
    }
    const currVal_377:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.getCurrencyCode(),'');
    if (import3.checkBinding(throwOnChange,this._expr_377,currVal_377)) {
      this.renderer.setText(this._text_155,currVal_377);
      this._expr_377 = currVal_377;
    }
    const currVal_378:any = (this.parentView.parentView.context.additionalSelected.addSelected != 'TOLL');
    if (import3.checkBinding(throwOnChange,this._expr_378,currVal_378)) {
      this.renderer.setElementProperty(this._el_163,'hidden',currVal_378);
      this._expr_378 = currVal_378;
    }
    valUnwrapper.reset();
    const currVal_379:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_13.transform('additionalPrice.toll.TOLL_SYSTEM')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_379,currVal_379))) {
      this.renderer.setText(this._text_172,currVal_379);
      this._expr_379 = currVal_379;
    }
    valUnwrapper.reset();
    const currVal_381:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_14.transform('additionalPrice.toll.SELECT_TOLL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_381,currVal_381))) {
      this.renderer.setText(this._text_175,currVal_381);
      this._expr_381 = currVal_381;
    }
    valUnwrapper.reset();
    const currVal_384:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_15.transform('additionalPrice.toll.UNLIMITED_TOLL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_384,currVal_384))) {
      this.renderer.setText(this._text_189,currVal_384);
      this._expr_384 = currVal_384;
    }
    const currVal_386:boolean = !this.parentView.parentView.context.showUnlimited;
    if (import3.checkBinding(throwOnChange,this._expr_386,currVal_386)) {
      this.renderer.setElementProperty(this._el_193,'hidden',currVal_386);
      this._expr_386 = currVal_386;
    }
    valUnwrapper.reset();
    const currVal_387:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_16.transform('additionalPrice.toll.UNLIMITED_TOLL_INFO')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_387,currVal_387))) {
      this.renderer.setText(this._text_200,currVal_387);
      this._expr_387 = currVal_387;
    }
    valUnwrapper.reset();
    const currVal_389:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_17.transform('additionalPrice.toll.UNLIMITED_TOLL_IMPORT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_389,currVal_389))) {
      this.renderer.setText(this._text_209,currVal_389);
      this._expr_389 = currVal_389;
    }
    const currVal_392:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.getCurrencyCode(),'');
    if (import3.checkBinding(throwOnChange,this._expr_392,currVal_392)) {
      this.renderer.setText(this._text_226,currVal_392);
      this._expr_392 = currVal_392;
    }
    valUnwrapper.reset();
    const currVal_393:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_19.transform('additionalPrice.toll.MAX_INFO')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_393,currVal_393))) {
      this.renderer.setText(this._text_233,currVal_393);
      this._expr_393 = currVal_393;
    }
    valUnwrapper.reset();
    const currVal_395:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_20.transform('additionalPrice.toll.HAS_EXPRESS_LANE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_395,currVal_395))) {
      this.renderer.setText(this._text_242,currVal_395);
      this._expr_395 = currVal_395;
    }
    valUnwrapper.reset();
    const currVal_399:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_23.transform('additionalPrice.toll.LIMITED_TOLL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_399,currVal_399))) {
      this.renderer.setText(this._text_273,currVal_399);
      this._expr_399 = currVal_399;
    }
    const currVal_401:boolean = !this.parentView.parentView.context.showLimited;
    if (import3.checkBinding(throwOnChange,this._expr_401,currVal_401)) {
      this.renderer.setElementProperty(this._el_277,'hidden',currVal_401);
      this._expr_401 = currVal_401;
    }
    valUnwrapper.reset();
    const currVal_402:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_24.transform('additionalPrice.toll.LIMITED_TOLL_INFO')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_402,currVal_402))) {
      this.renderer.setText(this._text_284,currVal_402);
      this._expr_402 = currVal_402;
    }
    valUnwrapper.reset();
    const currVal_404:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_25.transform(this.parentView.parentView.context.errorMessages['tollSelection'])),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_404,currVal_404))) {
      this.renderer.setText(this._text_292,currVal_404);
      this._expr_404 = currVal_404;
    }
    valUnwrapper.reset();
    const currVal_406:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_26.transform('common.SAVE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_406,currVal_406))) {
      this.renderer.setText(this._text_304,currVal_406);
      this._expr_406 = currVal_406;
    }
    valUnwrapper.reset();
    const currVal_408:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_27.transform('common.CANCEL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_408,currVal_408))) {
      this.renderer.setText(this._text_307,currVal_408);
      this._expr_408 = currVal_408;
    }
    this.compView_146.internalDetectChanges(throwOnChange);
    this.compView_185.internalDetectChanges(throwOnChange);
    this.compView_218.internalDetectChanges(throwOnChange);
    this.compView_250.internalDetectChanges(throwOnChange);
    this.compView_259.internalDetectChanges(throwOnChange);
    this.compView_269.internalDetectChanges(throwOnChange);
    if (!throwOnChange) {
      if ((this.numberOfChecks === 0)) { this._InputContainerComponent_146_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._CheckboxContainerComponent_185_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._InputContainerComponent_218_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._RadioContainerComponent_250_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._RadioContainerComponent_259_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._CheckboxContainerComponent_269_3.context.ngAfterViewInit(); }
    }
  }
  destroyInternal():void {
    this._vc_43.destroyNestedViews();
    this._vc_80.destroyNestedViews();
    this._vc_116.destroyNestedViews();
    this._vc_158.destroyNestedViews();
    this._vc_288.destroyNestedViews();
    this.compView_146.destroy();
    this.compView_185.destroy();
    this.compView_218.destroy();
    this.compView_250.destroy();
    this.compView_259.destroy();
    this.compView_269.destroy();
    this._InputContainerComponent_146_3.ngOnDestroy();
    this._CheckboxContainerComponent_185_3.ngOnDestroy();
    this._InputContainerComponent_218_3.ngOnDestroy();
    this._RadioContainerComponent_250_3.ngOnDestroy();
    this._RadioContainerComponent_259_3.ngOnDestroy();
    this._CheckboxContainerComponent_269_3.ngOnDestroy();
    this._NgForm_0_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
    this._pipe_translate_10.ngOnDestroy();
    this._pipe_translate_11.ngOnDestroy();
    this._pipe_translate_12.ngOnDestroy();
    this._pipe_translate_13.ngOnDestroy();
    this._pipe_translate_14.ngOnDestroy();
    this._pipe_translate_15.ngOnDestroy();
    this._pipe_translate_16.ngOnDestroy();
    this._pipe_translate_17.ngOnDestroy();
    this._pipe_translate_18.ngOnDestroy();
    this._pipe_translate_19.ngOnDestroy();
    this._pipe_translate_20.ngOnDestroy();
    this._pipe_translate_21.ngOnDestroy();
    this._pipe_translate_22.ngOnDestroy();
    this._pipe_translate_23.ngOnDestroy();
    this._pipe_translate_24.ngOnDestroy();
    this._pipe_translate_25.ngOnDestroy();
    this._pipe_translate_26.ngOnDestroy();
    this._pipe_translate_27.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 43)) { return new View_AdditionalEditComponent3(this.viewUtils,this,43,this._anchor_43,this._vc_43); }
    if ((nodeIndex == 80)) { return new View_AdditionalEditComponent4(this.viewUtils,this,80,this._anchor_80,this._vc_80); }
    if ((nodeIndex == 116)) { return new View_AdditionalEditComponent6(this.viewUtils,this,116,this._anchor_116,this._vc_116); }
    if ((nodeIndex == 158)) { return new View_AdditionalEditComponent9(this.viewUtils,this,158,this._anchor_158,this._vc_158); }
    if ((nodeIndex == 288)) { return new View_AdditionalEditComponent10(this.viewUtils,this,288,this._anchor_288,this._vc_288); }
    return (null as any);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._NgForm_0_3.handleEvent(eventName,$event) && result);
    return result;
  }
  handleEvent_31(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.context.checkAll(true)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_34(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.context.checkAll(false)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_146(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.context.additionalSelected.baseAmount = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_185(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.context.showUnlimited = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      this.parentView.parentView.context.unlimitedToll = {
        addSelected: (null as any),
        baseAmount: 0,
        lane: true
      }
      ;
      this.parentView.parentView.context.includeUnlimitedToll($event);
      const pd_sub_1:any = ((<any>(this.parentView.parentView.context.errors['unlimitedTollBaseAmount'] = (null as any))) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_218(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.context.unlimitedToll.baseAmount = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_250(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.context.unlimitedToll.lane = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_259(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.context.unlimitedToll.lane = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_269(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.context.showLimited = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      this.parentView.parentView.context.toll = {
        addSelected: 'TOLL_CONS_PER_DAY',
        baseAmount: 0
      }
      ;
      const pd_sub_1:any = ((<any>(this.parentView.parentView.context.errors['limitedTollBaseAmount'] = (null as any))) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_303(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.context.save()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_306(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.context.cancel()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_AdditionalEditComponent12 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  /*private*/ _expr_17:any;
  _pipe_translate_0:import27.TranslatePipe;
  /*private*/ _expr_19:any;
  /*private*/ _expr_20:any;
  _pipe_translate_1:import27.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_AdditionalEditComponent12,renderType_AdditionalEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_17 = import24.UNINITIALIZED;
    this._expr_19 = import24.UNINITIALIZED;
    this._expr_20 = import24.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-container eva3-restyle'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12 -eva-3-pt-xlg'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'dsp-message',new import3.InlineArray4(4,'closable','false','type','warning'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                        ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'h5',new import3.InlineArray2(2,'class','eva-3-h5 message-text -eva-3-pt-sm'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'a',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_12 = this.renderer.createText(this._el_8,'\n                        ',(null as any));
    this._text_13 = this.renderer.createText(this._el_6,'\n                    ',(null as any));
    this._text_14 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._text_15 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_16 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._pipe_translate_0 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import27.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._text_16
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import24.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_17:any = import3.inlineInterpolate(1,'\n                            ',valUnwrapper.unwrap(this._pipe_translate_0.transform('additionalPrice.ADDITIONAL_PRICE_REQUIRED_DESCRIPTION')),'\n                            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_17,currVal_17))) {
      this.renderer.setText(this._text_9,currVal_17);
      this._expr_17 = currVal_17;
    }
    const currVal_19:any = import3.inlineInterpolate(1,'company/',this.parentView.parentView.context.companyOid,'/pointOfSale');
    if (import3.checkBinding(throwOnChange,this._expr_19,currVal_19)) {
      this.renderer.setElementProperty(this._el_10,'href',this.viewUtils.sanitizer.sanitize(import46.SecurityContext.URL,currVal_19));
      this._expr_19 = currVal_19;
    }
    valUnwrapper.reset();
    const currVal_20:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('additionalPrice.POS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_20,currVal_20))) {
      this.renderer.setText(this._text_11,currVal_20);
      this._expr_20 = currVal_20;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_AdditionalEditComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import23.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import33.Wrapper_NgIf;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _vc_4:import23.ViewContainer;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import33.Wrapper_NgIf;
  _text_5:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import23.ViewContainer) {
    super(View_AdditionalEditComponent1,renderType_AdditionalEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','container-fluid whitesmoke-section'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import23.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import30.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import33.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_4 = new import23.ViewContainer(4,0,this,this._anchor_4);
    this._TemplateRef_4_5 = new import30.TemplateRef_(this,4,this._anchor_4);
    this._NgIf_4_6 = new import33.Wrapper_NgIf(this._vc_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._anchor_4,
      this._text_5
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import30.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import34.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import30.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import34.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:boolean = (!!this.parentView.context.pointsOfSale && (this.parentView.context.pointsOfSale.length > 0));
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    const currVal_4_0_0:boolean = (!this.parentView.context.pointsOfSale || (this.parentView.context.pointsOfSale.length == 0));
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.ngDoCheck(this,this._anchor_4,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    this._vc_4.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this._vc_4.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_AdditionalEditComponent2(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    if ((nodeIndex == 4)) { return new View_AdditionalEditComponent12(this.viewUtils,this,4,this._anchor_4,this._vc_4); }
    return (null as any);
  }
}
var renderType_AdditionalEditComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_AdditionalEditComponent,{});
export class View_AdditionalEditComponent0 extends import1.AppView<import0.AdditionalEditComponent> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import23.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import33.Wrapper_NgIf;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_AdditionalEditComponent0,renderType_AdditionalEditComponent,import8.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-slide -up -start'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import23.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import30.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import33.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_4 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._text_4
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import30.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import34.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = (this.context.endLoading == 0);
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_AdditionalEditComponent1(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/additional/additional-edit.component.ngfactory.ts